import React from "react";

let externalFonts= [];
if(window.getExternalFonts) {
  externalFonts = window.getExternalFonts();
}
var externalFontsArray = [];

if (externalFonts.length > 0) {
  externalFonts.forEach(fontName => {
    externalFontsArray.push({ 
      Title: fontName, 
      style: { fontFamily: fontName, color: "#0072c6" }, 
      Value: fontName 
    });
  });
}

const fontWeightObject = {
  type: "combo",
  label: "Font Weight",
  children: [
    { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
    { Title: "Bold", Value: "Bold" },
    { Title: "Bold Italic", Value: "Bold Italic" }
  ],
  alignment: "left",
  styleKey: "FontWeight",
}

const ControlsMap = {
  // 'Visible' : {'type':'combo', 'label':'Visible', 'children':[
  //     {'Title':'Yes', 'Value':'Yes'},
  //     {'Title':'No', 'Value':'No'}
  // ]},
  //Wizard and Side Naviagation
  RadioAlignment: {
    type: "combo",
    label: "Radio Options Alignment",
    alignment: "left",
    children: [
        { Title: "Vertical", Value: "vertical" },
        { Title: "Horizontal", Value: "horizontal" }
    ]
  },
  ToggleShort: {
    type: "toggleshort",
  },
  PickList: {
    type: "picklist",
  },
  EventButton: {
    type: "eventbutton",
  },
  BusinessFunctionButton: {
    type: "businessfunctionbutton",
  },
  StepsSubsteps: { type: "stepssubsteps" },

  MobileVisible: { type: "toggle", label: "On Mobile" },
  TabsVisible: { type: "toggle", label: "On Tabs" },
  headingPrimary :{type:"tab",label:"Primary"},

  Visible: { type: "toggle", label: "Visible" },
  HideSelectAllOption: { type: "toggle", label: "Hide Select All Option" },
  LabelAsSubSection: { type: "toggle", label: "Label As SubSection" },
  StretchToColumnWidth:{ type: "toggle", label: "Stretch to Column's Width" },

  AllowSearching: { type: "toggleallow", label: "Allow Searching" },
  // Header:{type:"toggle",label:"Header"},
  Header1:{type:"toggle",label:"Header"},

  // Footer:{type:"toggle",label:"Header"},
  AllowFreeTextInDropdown: {
    type: "toggleallow",
    label: "Allow Free Text in Dropdown",
  },

  ToggleBtn: { type: "toggle" },
  TogBtn: { type: "togbtn" },
  Alignment: {
    type: "combo",
    label: "Alignment",
    children: [
      { Title: "Horizontal Alignment", Value: "Horizontal" },
      { Title: "Vertical Alignment", Value: "Vertical" },
    ],
  },
  LeftRightAlignment: { type: "LeftRightAlignment" },
  ShowPasswordIcon: {
    type: "toggle",
    label: "View Password Icon",
    alignment: "left",
  },
  Layout: { type: "layout" },
  longinput: {
    type: "longinput",
  },
  Toggle: {
    type: "toggletype2",
  },
  // 'Label' : {'type':'toggle', 'label':'Label'},
  SelectAlignment: {
    type: "select",
    children: [
      { Title: "Horizontal", Value: "horizontal" },
      { Title: "Vertical", Value: "vertical" },
    ],
  },
  subformLabel: {
    type: "inputControl",
    label: "Label",
    children: [],
    regexType: "Allchar",
  },
  SubformWidth: { type: "input", label: "Width", field: "width", regexType: "NumericPositive" },
  SubformHeight: { type: "input", label: "Height", field: "height", regexType: "NumericPositive" },
  primaryButton1: { type: "input", label: "Primary Button 1", field: "Primary Button 1", regexType: "NumericPositive" },
  Label: { type: "textbox", label: "Label", regexType: "Allchar" },
  LabelNew: { type: "textarea", label: "Label", regexType: "Allchar" },
  PopupText: { type: "textbox", label: "Popup Text", regexType: "Allchar" },
  // 'LabelTextbox' : {'type':'textbox', 'label':'Label', 'regexType' : 'Allchar'},
  PicklistCaption: { type: "textarea", label: "Caption", regexType: "Allchar" },
  OptionsSelect: { type: "optionsselect" },
  heightselect: { type: "heightselect" },
  BackgroundSelect: { type: "backgroundselect" },
  Icon: { type: "button", label: "Icon" },
  columnVisibility: { type: "toggle", label: "Visible" },
  AddTab: { type: "button", label: "Add Tab" },
  Text: { type: "text" },
  colheight: { type: "text", regexType: "NumericPositive" },
  colPadding: { type: "toggle", label: "Remove Padding" },
  TextLabel: { type: "label" },
  TitleLabel: { type: "label", label: "Title", color: "#000000", weight: "600" },
  HeaderLabel: { type: "label", label: "Header", color: "#0072C6", weight: "600"},
  OuterSpacing: { type: "label", label: "Outer Spacing", color: "#0072C6", weight: "600"},
  InnerSpacing: { type: "label", label: "Inner Spacing", color: "#0072C6", weight: "600"},
  FooterLabel:{type:"label",label:"Footer",color: "#0072C6", weight: "600"},
  OuterPadding:{type:"label",label:"Outer Padding",color: "#000000", weight: "600"},
  InnerPadding:{type:"label",label:"Inner Padding",color: "#000000", weight: "600"},
  ButtonsubformLabel:{type:"label",label:"Button",color: "#000000", weight: "600" },
  Line: { type: "line" },
  TextTabLabel: { type: "text", label: "TextTabLabel" },
  TextArea: { type: "textarea", label: "", regexType: "AllChar" },
  TextArea1: { label: "Label",type: "textarea", field: "label", regexType: "AllChar" },
  AddIcons: { type: "toggle", label: "Add Icons" },
  StyleOptions: { type: "styleoptions" },
  CardLabelValue: { type: "cardlabelvalue" },
  widebutton: { type: "widebutton" },
  LongRadio: { type: "longradio" },
  CropLink: { type: "croplink" },
  SmallOptionSelect: { type: "smalloptionselect" },
  shortInput: { type: "input", regexType: "NumericPositive" },
  Enable: { type: "toggle", label: "Enable" },
  Inputradio: { type: "inputradio" },
  TableScrollRadio: { type: "inputradio", field: "TableScrollRadio", options: [
    { name: "Default (Scroll after 4 rows)", value: "defaultGridScroll" },
    // { name: "Till Page Height", value: "tillPageHeight" },
    { name: "Custom (Set max no. of rows)", value: "customGridHeightRows" },
    { name: "Custom (Table height in pixel)", value: "customGridHeightPixels" }
  ] },
  GridModalType: { type: "inputradio", field: "GridModalType", options: [
    { name: "Through Modal", value: "modal" },
    { name: "Section above Advance Listview", value: "aboveSection" },
    { name: "Section below Advance Listview", value: "belowSection" }
  ] },
  listviewBackground:{
    type:"toggle",
    label:"Add background behind Listview"
  },
  backgroundFillType:{
    type: "colorpicker",
    label: "Background Color",
    children: [],
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  bgBorderRadius:{
    type: "combo",
    label: "Border Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
      { Title: "16", Value: "16px" },
    ],
    alignment: "right",
    styleKey: "CornerRadius",
  },

  CustomGridScrollRows: {regexType: "NumericPositive", field: "Custom (Set max no. of rows)"},
  ListviewPopupWidth: { type: "input", label: "Width", field: "width", regexType: "NumericPositive" },
  ListviewPopupHeight: { type: "input", label: "Height", field: "height", regexType: "NumericPositive" },
  AdvListviewPopupWidth: { type: "input", label: "Width", field: "width", regexType: "NumericPositive" },
  AdvListviewPopupHeight: { type: "input", label: "Height", field: "height", regexType: "NumericPositive" },
  Editable: { type: "toggle", label: "Editable" },
  ManualInput: { type: "toggle", label: "Manual Input" },
  MandatoryOnDisable: { type: "toggle", label: "Mandatory on disable" },

  validateMandatoryDisable: { type: "toggle", label: "Mandatory on disable" },
  Header: {
    type: "toggle",
    label: "Header"
  },
  PreviousNextButtonWhileEdit : {
    type: "toggle",
    label: "Previous/Next button while Edit"
  },
  AdvListviewBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  listviewBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  AdvListviewHeaderLabel: { type: "label", label: "Header", color: "#0072C6", weight: "600"},
  listviewHeaderLabel: { type: "label", label: "Header", color: "#0072C6", weight: "600"},
  WhileAddingRow: { type: "label", label: "While Adding Row", color: "#0072C6", weight: "600"},
  WhileEditingRow: { type: "label", label: "While Editing Row", color: "#0072C6", weight: "600"},
  AdvListviewFooterLabel:{type:"label",label:"Footer",color: "#0072C6", weight: "600"},
  listviewFooterLabel:{type:"label",label:"Footer",color: "#0072C6", weight: "600"},
  AdvListviewHeaderBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  listviewHeaderBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  AdvListviewHeaderFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      {'Title':'Select', 'style':{fontFamily:""}, 'Value':'Select'},
      ...externalFontsArray,
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
    alignment: "left",
    styleKey: "FontFamily",
  },
  AdvListviewHeaderFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
    alignment: "right",
    styleKey: "FontSize",
  },
  AdvListviewHeaderFontWeight: fontWeightObject,
  PrimaryButton_FontWeight: fontWeightObject,
  SecondaryButton_FontWeight: fontWeightObject,
  AdvListviewHeaderFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "FontColor",
  },
  listviewHeaderFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      {'Title':'Select', 'style':{fontFamily:""}, 'Value':'Select'},
      ...externalFontsArray, 
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
    alignment: "left",
    styleKey: "FontFamily",
  },
  listviewHeaderFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
    alignment: "right",
    styleKey: "FontSize",
  },
  listviewHeaderFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'},
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "Italic" },
    ],
    alignment: "left",
    styleKey: "FontWeight",
  },
  listviewHeaderFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "FontColor",
  },
  primaryFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      {'Title':'Select', 'style':{fontFamily:""}, 'Value':'Select'},
      
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
    alignment: "left",
    styleKey: "FontFamily",
  },
  primaryFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
    alignment: "right",
    styleKey: "FontSize",
  },
  primaryFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'},
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "Italic" },
    ],
    alignment: "left",
    styleKey: "FontWeight",
  },
 primaryFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "FontColor",
  },
  secondaryFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      {'Title':'Select', 'style':{fontFamily:""}, 'Value':'Select'},
      
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
    alignment: "left",
    styleKey: "FontFamily",
  },
  secondaryFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
    alignment: "right",
    styleKey: "FontSize",
  },
  secondaryFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'},
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "Italic" },
    ],
    alignment: "left",
    styleKey: "FontWeight",
  },
 secondaryFontColor: {
    type: "colorpicker",
    label: "Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "FontColor",
  },
  AdvListviewFooterBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  listviewFooterBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  primaryBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  EnableMandatoryOnDisable: {
    type: "combo",
    label: "Enable Mandatory On Disable",
    children: [
      { Title: "No", Value: "No" },
      { Title: "Yes", Value: "Yes" },
    ],
  },
  LineBreak: {
    type: "combo",
    label: "Line-Break",
    children: [
      { Title: "No", Value: "No" },
      { Title: "Yes", Value: "Yes" },
    ],
  },
  FontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      { Title: "Select", Value: "Select"},
      { Title: "Normal", Value: "normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Italic", Value: "italic" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
    alignment: "left",
    styleKey: "FontWeight",
  },
  HeaderFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'},
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "Italic" },
    ],
    alignment: "left",
    styleKey: "FontWeight",
  },
  FooterFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'},
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "Italic" },
    ],
    alignment: "left",
    styleKey: "FontWeight",
  },
  LabelFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}
      {Title:'Select', Value:'Select'},
      { Title: "Normal", Value: "normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Italic", Value: "italic" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
  },
  MergeCell: {
    type: "combo",
    label: "Merge Cell",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "1", Value: "1" },
      { Title: "2", Value: "2" },
      { Title: "3", Value: "3" },
      { Title: "4", Value: "4" },
      { Title: "5", Value: "5" },
      { Title: "6", Value: "6" },
      { Title: "7", Value: "7" },
      { Title: "8", Value: "8" },
      { Title: "9", Value: "9" },
      { Title: "10", Value: "10" },
      { Title: "11", Value: "11" },
      { Title: "12", Value: "12" },
    ],
  },
  FontStyle: {
    type: "combo",
    label: "Font-style",
    children: [
      { Title: "Normal", Value: "Normal" },
      { Title: "Italic", Value: "italic" },
      // {'Title':'Oblique', 'Value':'oblique'}
    ],
  },
  LabelFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      {'Title':'Select', 'style':{fontFamily:""}, 'Value':'Select'},  
      ...externalFontsArray,       
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  FontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      {'Title':'Select', 'style':{fontFamily:""}, 'Value':'Select'},
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
    alignment: "left",
    styleKey: "FontFamily",
  },
  HeaderFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      {'Title':'Select', 'style':{fontFamily:""}, 'Value':'Select'},
      ...externalFontsArray,
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
    alignment: "left",
    styleKey: "FontFamily",
  },
  FooterFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      {'Title':'Select', 'style':{fontFamily:""}, 'Value':'Select'},
      ...externalFontsArray,
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
    alignment: "left",
    styleKey: "FontFamily",
  },

  ActiveTabFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },

  ActiveTabFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'},
      { Title: "Normal", Value: "normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Italic", Value: "italic" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
  },

  ActiveTabFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },

  InActiveTabFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },

  InActiveTabFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}
      { Title: "Select", Value: "" },
      { Title: "Normal", Value: "normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Italic", Value: "italic" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
  },

  ActiveStepFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "italic" },
      { Title: "Normal", Value: "normal" },
    ],
  },

  InActiveStepFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "italic" },
      { Title: "Normal", Value: "normal" },
    ],
  },

  InActiveTabFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },

  IconSize: {
    type: "iconcombo",
    label: "Icon Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "32", style: { fontSize: "12px" }, Value: "32px" },
      { Title: "36", style: { fontSize: "12px" }, Value: "36px" },
      { Title: "40", style: { fontSize: "12px" }, Value: "40px" },
    ],
  },

  LabelFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },

  FontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
    alignment: "right",
    styleKey: "FontSize",
  },
  HeaderFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
    alignment: "right",
    styleKey: "FontSize",
  },
  FooterFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
    alignment: "right",
    styleKey: "FontSize",
  },
  SubStepFontSize: {
    type: "combo",
    label: "SubStep Font Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
    alignment: "right",
    styleKey: "FontSize",
  },

  Style: {
    type: "combo",
    label: "Style",
    children: [
      { Title: "Style1", Value: "Style1" },
      { Title: "Style2", Value: "Style2" },
      { Title: "Style3", Value: "Style3" },
    ],
  },
  VerticalAlignment: {
    type: "combo",
    label: "Vertical Alignment",
    children: [
      { Title: "Top", Value: "Top" },
      { Title: "Center", Value: "Center" },
      { Title: "Bottom", Value: "Bottom" },
    ],
  },

  LabelAlignment: {
    type: "combo",
    label: "Label Alignment",
    children: [
      { Title: "Left", Value: "Left" },
      { Title: "Center", Value: "Center" },
      { Title: "Right", Value: "Right" },
    ],
  },

  LabelAlignmentSlider: {
    type: "combo",
    label: "Label Alignment",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Left", Value: "Left" },
      { Title: "Right", Value: "Right" },
    ],
  },

  LinkAlignment: {
    type: "combo",
    label: "Link Alignment",
    children: [
      { Title: "Left", Value: "Left" },
      { Title: "Center", Value: "Center" },
      { Title: "Right", Value: "Right" },
    ],
  },

  FontColorSlider: { type: "colorpicker", label: "Font Color", children: [] },
  ActiveSliderBar: {
    type: "colorpicker",
    label: "Active Slider Bar",
    children: [],
  },
  InActiveSliderBar: {
    type: "colorpicker",
    label: "InActive Slider Bar",
    children: [],
  },
  ActiveStateColor: {
    type: "colorpicker",
    label: "Active State Color",
    children: [],
  },

  FontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "FontColor",
  },
  HeaderFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "FontColor",
  },
  subformCancelColor:{
    type: "colorpicker",
    label: "Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "FontColor",
  },
  FooterFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "FontColor",
  },
  // ButtonBackgroundColor: {
  //   type: "colorpicker",
  //   label: "Background Color",
  //   children: [],
  //   regexType: "Fontcolor",
  //   alignment: "right",
  //   styleKey: "BackgroundColor",
  // },
  // 'ColumnHeaderColor':{'type':'colorpicker', 'label':'Column Header Color', 'children':[],'regexType':'ColumnHeaderColor',"alignment":"right","styleKey":"ColumnHeaderColor"},
  FontColorLabel: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  BackColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },
  BackColorLabel: {
    type: "colorpicker",
    label: "Back Color",
    children: [],
    regexType: "Fontcolor",
  },

  ActiveTabFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  ActiveTabBackColor: {
    type: "colorpicker",
    label: "Back Color",
    children: [],
    regexType: "Fontcolor",
  },
  InActiveTabFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  InActiveTabBackColor: {
    type: "colorpicker",
    label: "Back Color",
    children: [],
    regexType: "Fontcolor",
  },
  InActiveStepFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  InActiveStepBackgroundColor: {
    type: "colorpicker",
    label: "Back Color",
    children: [],
    regexType: "Fontcolor",
  },
  ActiveStepFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  ActiveStepBackgroundColor: {
    type: "colorpicker",
    label: "Back Color",
    children: [],
    regexType: "Fontcolor",
  },

  IconLabelAlignment: {
    type: "combo",
    label: "Icon - Label Alignment",
    children: [
      { Title: "Left Right", Value: "Left Right" },
      { Title: "Top Bottom", Value: "Top Bottom" },
    ],
  },
  LabelValueAlignment: {
    type: "combo",
    label: "Label-Value Alignment",
    children: [
      { Title: "Left Right", Value: "Left Right" },
      { Title: "Top Bottom", Value: "Top Bottom" },
    ],
  },
  ArabicLanguage: {
    type: "combo",
    label: "Date-Language",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Arabic", Value: "Arabic" },
      { Title: "Hijri", Value: "Hijri" },
    ],
  },
  // 'EALanguage': {'type':'combo', 'label':'EALanguage', 'children':[
  //     {'Title':'English', 'Value':'English'},
  //     {'Title':'Arabic', 'Value':'Arabic'},
  // ]},
  ThemeDateFormat: {
    type: "combo",
    label: "Date Format",
    children: [
      { Title: "DD/MM/YYYY", Value: "1" },
      { Title: "MM/DD/YYYY", Value: "2" },
      { Title: "YYYY/MM/DD", Value: "3" },
      { Title: "DD/MMM/YYYY", Value: "4" },
    ],
  },
  ThemeDateFormat2: {
    type: "combo",
    label: "Date Format",
    children: [
      { Title: "DD/MM/YYYY, HH:MM", Value: "5" },
      { Title: "MM/DD/YYYY, HH:MM", Value: "6" },
      { Title: "YYYY/MM/DD, HH:MM", Value: "7" },
      { Title: "DD/MMM/YYYY, HH:MM", Value: "8" },
    ],
  },
  GridDateSeperator: {
    type: "combo",
    label: "DateSeperator",
    styleKey: "DateSeperator",
    alignment: "right",
    children: [
      { Title: "Select", Value: "" },
      { Title: "/", Value: "1" },
      { Title: "-", Value: "2" },
      { Title: ".", Value: "3" },
    ],
  },
  DateSeperator: {
    type: "combo",
    label: "DateSeperator",
    children: [
      { Title: "/", Value: "1" },
      { Title: "-", Value: "2" },
      { Title: ".", Value: "3" },
    ],
  },
  DateTimeSeperator: {
    type: "combo",
    label: "DateSeperator",
    children: [
      { Title: "/", Value: "1" },
      { Title: "-", Value: "2" },
      { Title: ".", Value: "3" },
    ],
  },
  LabelRatio: {
    type: "combo",
    label: "Label-Ratio",
    children: [
      { Title: "25:75", Value: "ratio1" },
      { Title: "30:70", Value: "ratio2" },
      { Title: "40:60", Value: "ratio3" },
      { Title: "50:50", Value: "ratio4" },
    ],
  },
  "BG Color": {
    type: "colorpicker",
    label: "BG Color",
    children: [],
    regexType: "Fontcolor",
  },
  Link: {
    type: "colorpicker",
    label: "Link",
    children: [],
    regexType: "Fontcolor",
  },
  HeaderBackColor: {
    type: "colorpicker",
    label: "Header BG Color",
    children: [],
    regexType: "Fontcolor",
  },
  AccordionColor: {
    type: "colorpicker",
    label: "Accordian Icon Color",
    children: [],
    regexType: "Fontcolor",
  },
  Border: {
    type: "colorpicker",
    label: "Border",
    children: [],
    regexType: "Fontcolor",
  },
  subformCornerRadius: {
    type: "combo",
    label: "Border Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
      { Title: "16", Value: "16px" },
    ],
    alignment: "right",
    styleKey: "CornerRadius",
  },
  CornerRadius: {
    type: "combo",
    label: "Corner Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
      { Title: "16", Value: "16px" },
    ],
    alignment: "right",
    styleKey: "CornerRadius",
  },

  ActiveTabCornerRadius: {
    type: "combo",
    label: "Corner Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
      { Title: "16", Value: "16px" },
    ],
  },

  // 'ReadOnly' : {'type':'combo', 'label':'ReadOnly Style', 'children':[
  //     {'Title':'No', 'Value':'No'},
  //     {'Title':'Yes', 'Value':'Yes'}
  // ]},

  ReadOnly: { type: "toggle", label: "ReadOnly" },
  ReadOnlyTextarea: { type: "toggle", label: "ReadOnly" },

  ReadOnly2: { type: "toggle", label: "ReadOnlyStyle" },
  ReadOnlyStyle: { type: "toggle", label: "ReadOnly Style" },
  ColumnTooltip: {
    type: "text",
    label: "Column Tooltip",
    children: [],
    alignment: "right",
    styleKey: "ColumnTooltip",
    regexType: "aplhaNumwithColonSpace",
  },
  Summary: {
    type: "text",
    label: "Summary",
    children: [],
    regexType: "Allchar",
  },
  "Label-InputAlignment": {
    type: "combo",
    label: "Label-Input Alignment",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Top-Down", Value: "Top-Down" },
      { Title: "Left-Right", Value: "Left-Right" },
    ],
  },
  "Label-InputAlignmentTextbox": {
    type: "combo",
    label: "Label-Value Alignment",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Top-Down", Value: "Top-Down" },
      { Title: "Left-Right", Value: "Left-Right" },
    ],
  },
  TextAlignmentTextbox: {
    type: "combo",
    label: "Text Alignment in value",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Left", Value: "Left" },
      { Title: "Center", Value: "Center" },
      { Title: "Right", Value: "Right" },
    ],
  },
  // CustomControlId: {
  //   type: "text",
  //   label: "Custom Control ID",
  //   children: [],
  //   regexType: "CustomControlRid",
  // },
  CustomControlId: {
    type: "fullwidthtextinput",
    label: "Custom Control ID",
    children: [],
    regexType: "CustomControlRid",
  },

  CustomId: {
    type: "text_top_bottom",
    label: "User Defined ID",
    children: [],
    regexType: "AlphaNumericWithUnderScoreStartingFromAlphabet",
  },

  // 'Placeholder':{'type':'text', 'label':'Placeholder', 'children':[]},
  Placeholder: {
    type: "text_top_bottom",
    label: "Placeholder",
    children: [],
    regexType: "NamewithSpaceUnderscoreRegEx",
  },

  DummyData: {
    type: "text_top_bottom",
    label: "Value",
    children: [],
    regexType: "Allchar",
  },

  AllowNumbers: {
    type: "toggle",
    label: "Allow Numbers",
    alignment: "left",
    styleKey: "AllowNumbers",
  },

  Numerals: { type: "toggle", label: "Allow Numbers", alignment: "left" },

  AllowAlphabets: {
    type: "toggle",
    label: "Allow Alphabets",
    alignment: "left",
    styleKey: "AllowAlphabets",
  },

  Alphabets: { type: "toggle", label: "Allow Alphabets", alignment: "left" },

  AllowSpaces: {
    type: "toggle",
    label: "Allow Spaces",
    alignment: "left",
    styleKey: "AllowSpaces",
  },

  Spaces: { type: "toggle", label: "Allow Spaces" },

  EmployeeIdTextArea: { type: "textarea", label: "" },

  ZoneList: {
    type: "combo",
    label: "Zone List",
    children: [
      { Title: "Ask", Value: "5pt" },
      { Title: "Ask2", Value: "10pt" },
      { Title: "Ask3", Value: "15pt" },
    ],
  },

  inputTypeOne: { type: "input" },

  SetRetryCount: { type: "text", label: "Set Retry Count", regexType: "NumericPositive", },
  SetRetryCount1: { type: "retrycountbox", label: "Set Retry Count", regexType: "NumericPositive"},

  MaxLength: {
    type: "text",
    label: "Max Length",
    children: [],
    alignment: "right",
    regexType: "NumericPositive",
  },

  MinValue: {
    type: "text",
    label: "Min Value",
    children: [],
    alignment: "right",
    regexType: "NumericPositiveNegitive",
  },
  MaxValue: {
    type: "text",
    label: "Max Value",
    children: [],
    alignment: "right",
    regexType: "NumericPositive",
  },

  MaxCharacterLength: {
    type: "text",
    label: "Max Character Length",
    children: [],
    alignment: "right",
    regexType: "NumericPositive",
  },
  line:{type: "hr", label: "line"},
  Fontsizepair: { type: "header", label: "Font Size Pair" },
  Labels: {
    type: "combo",
    label: "Labels",
    children: [
      { Title: "10", Value: "10" },
      { Title: "11", Value: "11" },
      { Title: "12", Value: "12" },
      { Title: "13", Value: "13" },
      { Title: "14", Value: "14" },
      { Title: "15", Value: "15" },
      { Title: "16", Value: "16" },
    ],
  },
  Values:{
    type: "combo",
    label: "Values",
    children: [ 
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
      { Title: "16", Value: "16px" },
      { Title: "17", Value: "17px" },
      { Title: "18", Value: "18px" },
      { Title: "19", Value: "19px" },
      { Title: "20" ,Value: "20px" },
      { Title: "21", Value: "21px" },
      { Title: "22", Value: "22px" },
      { Title: "23", Value: "23px" },
      { Title: "24", Value: "24px" },
      { Title: "25", Value: "25px" },
      { Title: "26", Value: "26px" },
      { Title: "27", Value: "27px" },
      { Title: "28", Value: "28px" },
      { Title: "29", Value: "29px" },
      { Title: "30", Value: "30px" },
    ],
  },
  MaxRowLength:{
    type: "text",
    label: "Number of Rows",
    children: [],
    alignment: "right",
    regexType: "NumericPositive",

  },
  fixedWidthAndHeight: {
    type: "text",
    label: "fixedWidthAndHeight",
    children: [],
    regexType: "NumericPositive",
  },
  variableWidthAndHeight: {
    type: "text",
    label: "fixedWidthAndHeight",
    children: [],
    regexType: "NumericPositive",
  },
  // 'CustomPattern':{'type':'text', 'label':'Custom Pattern', 'children':[]},
  formBackgroundColorInputBox: { type: "colorpicker", regexType: "Fontcolor" },
  formBackgroundColorInnerSquareBox: {
    type: "colorpicker",
    regexType: "Fontcolor",
  },

  TextOverflowBehaviour: {
    type: "combo",
    label: "Text Overflow Behaviour",
    children: [
      { Title: "None", Value: "None" },
      { Title: "Truncate", Value: "Truncate" },
      { Title: "Viewmore/less", Value: "Viewmore/less" },
    ],
  },

  CharactersToBeShown: {
    type: "text",
    label: "No. of characters to be shown before truncation",
    children: [],
    alignment: "right",
    regexType: "NumericPositive",
  },

  CharacterSet: {
    type: "combo",
    label: "Character Set",
    children: [
      { Title: "SELECT", Value: "Select" },
      { Title: "UPPERCASE", Value: "Uppercase" },
      { Title: "LOWERCASE", Value: "Lowercase" },
    ],
    alignment: "right",
  },

  doclistMapping: { type: "mapping", label: "Mapping" },

  // 'Mapping' : {'type':'combo', 'label':'Mapping', 'children':[]},

  MappingField: {
    type: "text_top_bottom",
    label: "Mapping Field",
    children: [],
  },

  // 'Mapping' : {'type':'combo', 'label':'Mapping', 'children':[]},

  Mapping: {
    type: "text_top_bottom",
    label: "Mapping",
    children: [],
    regexType: "Allchar",
  },
  PickList_Mf:{'type':'microfrontend', 'label':'Associate Picklist Data Object'},
    
  UserDefinedControlID: {
    type: "text_top_bottom",
    label: "User defined ID",
    regexType: "CustomControlRid",
  },
  // "CustomId" : {'type':'text_top_bottom', 'label':'User defined ID',
  // 'regexType':'CustomControlRid'},

  LinkURL: { type: "text_top_bottom_method", label: "Enter URL", children: [] },
  MethodName: {
    type: "text_top_bottom_method",
    label: "Method Name",
    children: [],
  },

  UserDefinedID: {
    type: "text_top_bottom",
    label: "User defined ID",
    children: [],
    regexType: "CustomControlRid",
  },

  LabelLabel: { type: "text_top_bottom", label: "Label", children: [] },

  // 'Label':{'type':'textarea', 'label':'Label', 'children':[]},

  DatepickerMapping: {
    type: "fullwidthtextinput",
    label: "Mapping",
    children: [],
  },

  TextAlignment: {
    type: "combo",
    label: "Text Alignment",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Left", Value: "left" },
      { Title: "Center", Value: "center" },
      { Title: "Right", Value: "right" },
    ],
  },
  BorderColor: {
    type: "colorpicker",
    label: "Border Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "buttonType",
  },
  ColorPicker: { type: "colorpicker", regexType: "Fontcolor" },

  TabBackgroundColor: {
    type: "colorpicker",
    label: "Tab Background Color",
    children: [],
    regexType: "Fontcolor",
  },
  TabAppearanceBorderColor: {
    type: "colorpicker",
    label: "Border Color",
    children: [],
    regexType: "Fontcolor",
  },
  // 'BackColor':{'type':'colorpicker', 'label':'Box Background Color', 'children':[]},
  BackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  SubformBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  HeaderBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  FooterBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },
  HoverColor: {
    type: "colorpicker",
    label: "Hover Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "HoverColor",
  },
  backgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },

  // 'Color':{'type':'colorpicker', 'label':'Color', 'children':[]},

  Color: {
    type: "colorpicker",
    label: "Color",
    children: [],
    regexType: "Fontcolor",
  },

  BorderWidth: {
    type: "combo",
    label: "Border Width",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
    ],
  },
  TabAppearanceBorderWidth: {
    type: "combo",
    label: "Border Width",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
    ],
  },

  BorderRadius: {
    type: "combo",
    label: "Border Radius",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
    ],
  },
  TabAppearanceBorderRadius: {
    type: "combo",
    label: "Border Radius",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
    ],
  },

  DefaultSorting: {
    type: "combolong",
    label: "Default Sorting on Options",
    children: [{ Title: "None", Value: "None" }],
  },

  DefaultSelect: {
    type: "combolong",
    label: "Default Option to be selected",
    children: [{ Title: "None", Value: "None" }],
  },

  MaskingValue: {
    type: "combo",
    label: "Input Pattern",
    children: [
      { Title: "No Masking", Value: "No Masking" },
      // {'Title':'No Masking', 'Value':'No Masking'},
      // {'Title':'Mobile', 'Value':'Mobile'},
      // {'Title':'PinCode', 'Value':'PinCode'},
      // {'Title':'Email', 'Value':'Email'},
      // {'Title':'Percentage', 'Value':'Percentage'},
      // {'Title':'Currency Dollar', 'Value':'CurrencyDollar'},
      // {'Title':'Currency Rupees', 'Value':'CurrencyRupees'},
      // {'Title':'Currency Yen', 'Value':'CurrencyYen'},
      // {'Title':'Currency Euro', 'Value':'CurrencyEuro'},
      // {'Title':'U.S Format', 'Value':'USFormat'},
      // {'Title':'SwissFranc', 'Value':'CurrencySwissFranc'},
      // {'Title':'Currency Naira', 'Value':'CurrencyNaira'},
      // {'Title':'Indian Format', 'Value':'IndianFormat'},
      // {'Title':'Password', 'Value':'Password'},
    ],
    alignment: "right",
    styleKey: "PatternMasking",
  },

  ColumnMasking: {
    type: "combo",
    label: "Masking Pattern",
    children: [{ Title: "No Masking", Value: "No Masking" }],
    alignment: "right",
    styleKey: "PatternMasking",
  },

  AllowMasking: { type: "toggle", label: "Allow Masking" },

  AllowCopy: {type:"toggle",label:"Allow Copy"},

  SpecialCharacters: {
    type: "textarea",
    label: "Special Characters",
    children: [],
    regexType: "AlphanumericwithAllSpecialCharacterswithSpace",
  },

  CustomPattern: {
    type: "text",
    label: "Custom Pattern",
    children: [],
    alignment: "right",
    regexType: "Allchar",
  },

  Tooltip: {
    type: "textarea",
    label: "Tooltip",
    children: [],
    regexType: "aplhaNumwithColonSpace",
  },

  SpecialCharacter: {
    type: "textareaspecialcharacter",
    label: "",
    children: [],
    regexType: "OnlySpecialCharacter",
  },

  MandatoryMessage: {
    type: "textareamandatorymessage",
    label: "",
    children: [],
    regexType: "AlphanumericwithAllSpecialCharacterswithSpace",
  },

  ValidationMessage: {
    type: "textareamandatorymessage",
    label: "",
    children: [],
    regexType: "AlphanumericwithAllSpecialCharacterswithSpace",
  },

  ControlLabel: { type: "textarea", label: "Label", children: [] },

  ControlDescription: {
    type: "textarea",
    label: "Control Description",
    children: [],
    regexType: "Allchar",
  },

  Query: {
    type: "textareaforquery",
    label: "Query",
    children: [],
    regexType: "Allchar",
  },

  GridMasterQuery: {
    type: "textareaforquery",
    label: "Master Query",
    children: [],
    field: "MasterQuery",
    regexType: "Allchar",
    alignment: "right",
    styleKey: "MasterQuery",
  },

  // 'SaveEncrypted' : {'type':'combo', 'label':'Save Encrypted', 'children':[
  //     {'Title':'No', 'Value':'No'},
  //     {'Title':'Yes', 'Value':'Yes'}
  //     ]},

  KeyCount: {
    type: "text",
    label: "Key Count",
    children: [],
    alignment: "right",
    regexType: "NumericPositive",
  },
  subformOverLay: { type: "subformTemplateButton", field:"Select Overlay Type",label: "Select Overlay Type", children: [] },
  selectOverlay: { type: "selectOverlayType", label: "", children: [] },
  SaveEncrypted: {
    type: "toggle",
    label: "Save Encrypted",
    alignment: "left",
    styleKey: "SaveEncrypted",
  },
  ShowDecrypted: {
    type: "toggle",
    label: "Show Decrypted",
    alignment: "left",
    styleKey: "ShowDecrypted",
  },

  AutoComplete: { type: "toggle", label: "Auto Complete", alignment: "left" },

  Cache: { type: "toggle", label: "Cache", alignment: "left" },
  Serach: { type: "toggle", label: "Serach", alignment: "left" },

  AllowSpecialChars: {
    type: "toggle",
    label: "Allow Special Characters",
    alignment: "left",
    styleKey: "AllowSpecialChars",
  },

  Identifier: {
    type: "combo",
    label: "Identifier",
    children: [
      { Title: "No", Value: "No" },
      { Title: "Yes", Value: "Yes" },
    ],
  },
  DateStyle: {
    type: "combo",
    label: "Date Style",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Calender View 1", Value: "Calender View 1" },
      { Title: "Calender View 2", Value: "Calender View 2" },
    ],
  },
  DateType: {
    type: "combo",
    label: "Date type",
    children: [
      { Title: "Date Picker", Value: "Date Picker" },
      { Title: "Date Time Picker", Value: "Date Time Picker" },
    ],
  },
  "Open-DatePicker": {
    type: "combo",
    label: "Open DatePicker",
    children: [
      { Title: "Yes", Value: "Yes" },
      { Title: "No", Value: "No" },
    ],
  },
  "Default-Value": {
    type: "combo",
    label: "Default Value",
    children: [
      { Title: "Empty", Value: "Empty" },
      { Title: "Current Date", Value: "Current Date" },
    ],
  },
  MaxDateAsCurrent: {
    type: "checkbox",
    stylekey:"MaxDate",
    alignment: "left",
    label: "Set today's date as maximum",
    children: [],
  },
  MaxDateAsCurrentTable: {
    type: "checkboxcurrentdate",
    stylekey:"MaxDate",
    alignment: "left",
    label: "Set today's date as maximum",
    children: [],
  },
  MinDate: {
    type: "date",
    styleKey: "MinDate",
    alignment: "left",
    label: "Min Date",
    children: [],
  },
  MinDateAsCurrent: {
    type: "checkbox",
    styleKey: "MinDate",
    alignment: "left",
    label: "Set today's date as minimum",
    children: [],
  },
  MinDateAsCurrentTable: {
    type: "checkboxcurrentdate",
    styleKey: "MinDate",
    alignment: "left",
    label: "Set today's date as minimum",
    children: [],
  },
  MaxDate: {
    type: "date",
    styleKey: "MaxDate",
    alignment: "left",
    label: "Max Date",
    children: [],
  },
  ManualInput: {
    type: "toggle",
    label: "Allow Manual Input",
    alignment: "left",
    styleKey: "ManualInput",
  },
  ComboType: {
    type: "combo",
    label: "Combo type",
    children: [
      { Title: "DropdownList", Value: "DropdownList" },
      { Title: "Dropdown", Value: "Dropdown" },
    ],
  },
  SortingOrder: { type: "text", label: "Sorting Order", children: [] },
  // 'ButtonLabel' : {'type':'text', 'label':'Button Label', 'children':[],'regexType':'Allchar'},
  ButtonLabelQuick: {
    type: "buttonlabel",
    label: "Button Label",
    children: [],
    regexType: "Allchar",
  },
  // 'ButtonType': {'type':'combo', 'label':'Button Type', 'children':[
  //     {'Title':'with rounded corners', 'Value':'with rounded corners'},
  //     {'Title':'without rounded corners', 'Value':'without rounded corners'}
  // ]},

  ButtonType: {
    type: "icon",
    children: [],
    alignment: "left",
    styleKey: "buttonType",
    label: "Button Type",
  },
  Icons: { type: "icon", label: "Icons", children: [] },

  IconsForText: { type: "icon", label: "IconsForText", children: [] },

  ButtonIcon: {
    type: "FileUpload",
    label: "Button Icon",
    children: [{ Title: "Browse From System", Value: "Upload File" }],
  },
  OnClick: {
    type: "boxWithIcon",
    label: "On Click",
    children: [
      { Title: "Page", Value: "Page" },
      { Title: "Subform", Value: "Subform" },
      { Title: "Link", Value: "Link" },
      { Title: "More", Value: "More" },
      { Title: "Code", Value: "Code" },
      { Title: "URL", Value: "URL" },
    ],
  },
  Subform: {
    type: "subformBox",
    label: "Subform",
    children: [
      { Title: "Create", Value: "Create", UpdatedTitle: "Edit" },
      { Title: "Upload", Value: "Upload" },
    ],
  },
  TabLabelsJustified: { type: "toggle", label: "Tab Labels Justified" },

  ShowBorder: { type: "toggle", label: "Show Border" },
  TabAppearanceShowBorder: { type: "toggle", label: "Show Border" },
  CustomControlIdFullWidth: {
    type: "fullWidthtextinput",
    label: "Custom Control Id",
    children: [],
    regexType: "CustomControlRid",
  },
  SubformTitle: {
    type: "fullWidthtextinput",
    label: "Subform Title",
    children: [],
    regexType: "Allchar",
  },
  AdvlistviewTitle: {
    type: "fullWidthtextinput",
    label: "Title",
    children: [],
    regexType: "Allchar",
  },
  listviewTitle: {
    type: "fullWidthtextinput",
    label: "Title",
    children: [],
    regexType: "Allchar",
  },
  showCancelButton:{
    type: "toggle",
    label: "Show Cancel Button"
  },
  // 1
  Footer: {
    type: "toggle",
    label: "Footer"
  },
  Template: { type: "subformTemplateButton", field:"Select Template",label: "Select Template", children: [] },
  inputSubform: { type: "fullwidthtextinputgrey", label: "", children: [] },
  Linebreak: { type: "toggle", label: "Line-break" },
  ShowSaveButtons: { type: "toggle", label: "Show Save Buttons" },
  GetDataOnDemand: { type: "toggle", label: "Get Data On Demand" },
  FixTabHeader: { type: "toggle", label: "Fix Tab Header" },
  AutoFitHeight: { type: "toggle", label: "Auto-Fit Height to Content" },

  IconAlignment: {
    type: "combo",
    label: "Icon Alignment",
    children: [
      { Title: "Left", Value: "Left" },
      { Title: "Right", Value: "Right" },
    ],
  },
  LabelOptionAlignment: {
    type: "combo",
    label: "Label-Option Alignment",
    children: [
      { Title: "Select", Value: "" },
      { Title: "Top Down", Value: "topDown" },
      // {"Title":"Down Top", "Value":"downTop"},
      { Title: "Left Right", Value: "leftRight" },
      // {"Title":"Right Left", "Value":"rightLeft"},
    ],
  },

  TextboxIcon: { type: "imageUpload", label: "Add Icon" },
  ButtonLink: { type: "longinput", label: "Add Link" },
  UploadLogo: { type: "imageUpload", label: "Upload Logo" },

  MultiDisplayType: { type: "toggle", label: "Display Type" },
  MultiShowIcon: { type: "toggle", label: "Add Icon" },
  ShowIcon: { type: "toggle", label: "Add Icon" },
  TableHeaderHeight: {
    type: "combo",
    label: "Height",
    children: [
      // { Title: "Default", Value: "36px" },
      { Title: "Compact", Value: "44px" },
      { Title: "Large", Value: "52px" },
    ],
  },
  TableHeader: { type: "header", label: "Table Column" },
  TableHeaderLineColor: {
    type: "colorpicker",
    label: "Line Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableHeaderBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableHeaderFontWeightStyle: {
    type: "combo",
    label: "Font Style",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

      { Title: "Normal", Value: "Normal" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "italic" },
    ],
  },
  TableHeaderFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  TableHeaderFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
    styleKey: "HeaderFontSize",
  },
  TableHeaderTextAlignment: {
    type: "combo",
    label: "Text Alignment",
    children: [
      { Title: "Left", Value: "Left" },
      { Title: "Right", Value: "Right" },
      { Title: "Center", Value: "Center" },
    ],
    styleKey: "LabelAlignment",
  },
  TableHeaderFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableRowFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableHeight: {
    type: "text",
    label: "Table Height",
    children: [],
    regexType: "NumericPositive",
  },
  TableTSelectedRowColor: {
    type: "colorpicker",
    label: "Selected Row/Cell Color",
    children: [],
    regexType: "Fontcolor",
  },
  LineColor: {
    type: "colorpicker",
    label: "Line Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableRowsHeight: {
    type: "combo",
    label: "Height",
    children: [
      // { Title: "Default", Value: "36px" },
      { Title: "Compact", Value: "44px" },
      { Title: "Large", Value: "52px" },
      { Title: "Custom", Value: "Custom" },
      { Title: "Auto", Value: "Auto" }
    ],
  },
  CustomRowHeight: { type: "text", label: "Set Height" },
  HoverEffect: { type: "toggle", label: "Hover Effect" },
  TextbreakCharacterCount: {
    type: "text",
    label: "Text Break Character Count",
    children: [],
    regexType: "NumericPositive",
  },
  RowCharacterCount: {
    type: "text",
    label: "Row Character Count",
    children: [],
    regexType: "NumericPositive",
  },
  // "AddRowButtonLabel" : {'type':'toggle', 'label':'Row Button Label'},
  SearchBar: { type: "toggle", label: "Search Bar" },
  Searching: { type: "toggle", label: "Search Bar" },
  ShowAddOption: { type: "toggle", label: "Show Add Option" },
  ShowDeleteOption: { type: "toggle", label: "Show Delete Option" },
  HideAddOption: { type: "toggle", label: "Hide Add Option" },
  HideDeleteOption: { type: "toggle", label: "Hide Delete Option" },
  HideAdd: { type: "toggle", label: "Hide Add Option" },
  GridTileView: { type: "toggle", label: "Show Table Row as Tile" },
  HideDelete: { type: "toggle", label: "Hide Delete Option" },
  HideMoreOptions: { type: "toggle", label: "Hide More Option" },
  ShowOverlayBatchsButtons: { type: "toggle", label: "Previous/Next button while Edit" },
  ShowFooter: { type: "toggle", label: "Footer" },
  ShowSaveChanges: { type: "toggle", label: "Save Changes button" },
  // HideOverlayBatchsButtons: { type: "toggle", label: "Previous/Next button" },
  ShowFooterWhenDisabled: { type: "toggle", label: "Show Footer when grid is disabled" },
  AdvListviewPopupAutoHeight: { type: "toggle", label: "Auto Height" },
  AllowDuplicatingRow: { type: "toggle", label: "Duplicate Row button" },
  AllowDownload: { type: "toggle", label: "Allow Download" },
  AllowUpload: { type: "toggle", label: "Allow Upload" },
  ShowCheckbox: { type: "toggle", label: "Show checkboxes", 'keyName':"customToggle"},
  ShowCheckboxDisabled: { type: "toggle", label: "Show checkboxes if disabled", 'keyName':"customToggle"},
  MultiSelect: { type: "toggle", label: "MultiSelect" },
  EnableTimeZone: { type: "toggle", label: "Enable Time Zone" },
  multiSelect: { type: "toggle", label: "MultiSelect" },
  timeZone: { type: "toggle", label: "Enable Time Zone" },
  ShowSerialNumber: { type: "toggle", label: "Show Serial Number" },
  HrTag: { type: "hr", label: "" },
  HrTag2: { type: "hr", label: "" },
  HrTag2HrTag: { type: "hr", label: "" },
  HrTagTableRow: { type: "hr", label: "" },
  HrTagListviewRow: { type: "hr", label: "" },
  HrTagDocumentType: { type: "hr", label: "" },
  HrTagUploadButtonType: { type: "hr", label: "" },
  HrTagBulkUploadButton: { type: "hr", label: "" },
  TableRows: { type: "header", label: "Table Rows" },
  TableScrollHeader: { type: "header", label: "Table Scroll", ToolTip: "Set no. of rows after which the table starts scrolling" },
  GridTileViewHeader: { type: "header", label: "Mobile View", ToolTip: "This property is used to specify how a table will appear on a mobile device." },
  Column1: { type: "fullWidthInput", label: "Column 1" },
  AddColumnButton: { type: "fullWidthInputButton", label: "Add Column(s)" },
  CustomProperties: {
    type: "fullWidthInputButton",
    label: "Custom Propertie(s)",
  },

  AddColumnButton2: {
    type: "fullWidthInputButton",
    children: [
      { Title: "Select From Page", Value: "Select From Page" },
      { Title: "+ Add Column(s)", Value: "ShowBackdrop To Add" },
    ],
  },
  // ColumnHeader: { type: "header", label: "Column Header", alignment: "left" },
  // ColumnHeaderButton: {
  //   type: "header",
  //   label: "Column Header",
  //   alignment: "right",
  // },
  // 'ColumnHeaderFontWeight' :  {'type':'smallcombo', 'label':'Font Weight', 'children':[
  // 							{'Title':'Normal', 'Value':'Normal'},
  // 							{'Title':'Bold', 'Value':'Bold'},
  // 							{'Title':'Bolder', 'Value':'bolder'},
  // 							{'Title':'Lighter', 'Value':'lighter'},
  // 							{'Title':'Initial', 'Value':'initial'}
  // 						],'alignment':'left','styleKey':'HeaderFontWeight'},
  ColumnHeaderFontWeightButton: {
    type: "smallcombo",
    label: "Font Weight",
    children: [
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bolder", Value: "bolder" },
      { Title: "Lighter", Value: "lighter" },
      { Title: "Initial", Value: "initial" },
    ],
    alignment: "right",
    styleKey: "HeaderFontWeight",
  },
  ColumnHeaderFontColor: {
    type: "colorpicker",
    label: "Color",
    children: [],
    alignment: "left",
    regexType: "Fontcolor",
    styleKey: "ColumnHeaderFontColor",
  },
  ColumnHeaderBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    alignment: "left",
    regexType: "Fontcolor",
    styleKey: "ColumnHeaderBackgroundColor",
  },
  ColumnHeaderAlignment: {
    type: "smallcombo",
    label: "Column Header Alignment",
    children: [
      { Title: "Left", Value: "left" },
      { Title: "Right", Value: "right" },
      { Title: "Center", Value: "center" },
    ],
    alignment: "left",
    styleKey: "LabelAlignment",
  },
  ColumnHeaderAlignmentButton: {
    type: "smallcombo",
    label: "Alignment",
    children: [
      { Title: "Left", Value: "left" },
      { Title: "Right", Value: "right" },
      { Title: "Center", Value: "center" },
    ],
    alignment: "right",
    styleKey: "LabelAlignment",
  },
  // ColumnValues: { type: "header", label: "Column Values", alignment: "right" },
  // 'ColumnValuesFontWeight' :  {'type':'smallcombo', 'label':'Font Weight', 'children':[
  // 							{'Title':'Normal', 'Value':'Normal'},
  // 							{'Title':'Bold', 'Value':'Bold'},
  // 							{'Title':'Bolder', 'Value':'bolder'},
  // 							{'Title':'Lighter', 'Value':'lighter'},
  // 							{'Title':'Initial', 'Value':'initial'}
  // 						],'alignment':'right','styleKey':'CellFontWeight'},
  ColumnValuesFontColor: {
    type: "colorpicker",
    label: "Color",
    children: [],
    alignment: "right",
    regexType: "Fontcolor",
    styleKey: "ColumnValuesFontColor",
  },
  ColumnValuesBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    alignment: "right",
    regexType: "Fontcolor",
    styleKey: "ColumnValuesBackgroundColor",
  },
  ColumnValuesAlignment: {
    type: "smallcombo",
    label: "Column Values Alignment",
    children: [
      { Title: "Left", Value: "left" },
      { Title: "Right", Value: "right" },
      { Title: "Center", Value: "center" },
    ],
    alignment: "right",
    styleKey: "CellLabelAlignment",
  },
  ColumnName: {
    type: "text",
    label: "Column Name",
    children: [],
    alignment: "left",
    styleKey: "ColumnName",
    regexType: "Allchar",
  },
  ButtonLabel: {
    type: "text",
    label: "Button Label",
    children: [],
    alignment: "left",
    styleKey: "ButtonLabel",
    regexType: "Allchar",
  },
  TableColumnLabel: {
    type: "text",
    label: "Label",
    children: [],
    alignment: "left",
    styleKey: "LabelOfColumnTypeLabel",
    regexType: "Allchar",
  },
  MethodName1: {
    type: "text",
    label: "Method Name",
    children: [],
    alignment: "left",
    styleKey: "MethodName1",
    regexType: "Allchar",
  },
  ListviewLinkURL: {
    type: "text",
    label: "Link URL",
    children: [],
    alignment: "left",
    styleKey: "ListviewLinkURL",
    regexType: "Allchar",
  },
  ColumnType: {
    type: "combo",
    label: "Column Type",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Textbox", Value: "textbox" },
      { Title: "Textarea", Value: "textarea" },
      { Title: "Richtext Editor", Value: "textarea", controlName: "richtexteditor" },
      { Title: "Password", Value: "password" },
      { Title: "DatePicker", Value: "datepick" },
      { Title: "DateTimePicker", Value: "datetimepick" },
      { Title: "Button", Value: "button" },
      // {'Title':'DatePicker', 'Value':'datepicker'},
      { Title: "Radio", Value: "radio" },
      { Title: "Multiselect", Value: "listbox" },
      { Title: "Dropdown", Value: "combo" },
      { Title: "Picklist", Value: "picklist" },
      { Title: "Label", Value: "label" },
      { Title: "Link", Value: "link" },
      { Title: "Checkbox", Value: "checkbox" },
      { Title: "Toggle", Value: "toggle" },
    ],
    alignment: "left",
    styleKey: "columnType",
  },
  ColumnWidth: {
    type: "combotext",
    label: "Column Width",
    children: [
      { Title: "Percentage", Value: "percentage" },
      { Title: "Pixels", Value: "pixel" },
    ],
    alignment: "left",
    styleKey: "ColumnWidth",
    regexType: "",
  },
  SortingType: {
    type: "toggle",
    label: "Sorting Type",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Disable", Value: "disable" },
      { Title: "Enable", Value: "enable" },
    ],
    alignment: "left",
    styleKey: "SortingType",
  },
  
  AssociatedField: {
    type: "combo",
    label: "Associated Field",
    children: [{ Title: "", Value: "" }],
    alignment: "right",
    styleKey: "associatedField",
  },
  ShowHeaderLabel: {
    type: "checkbox",
    label: "Show Header Label",
    children: [],
    alignment: "BottomDiv1",
    styleKey: "ShowHeaderLabel",
  },
  ShowCellData: {
    type: "checkbox",
    label: "Show Cell Data",
    children: [],
    alignment: "BottomDiv1",
    styleKey: "ShowCellData",
  },
  VisibleOnTable: {
    type: "checkbox",
    label: "Visible On Table",
    children: [],
    alignment: "BottomDiv1",
    styleKey: "VisibleOnTable",
  },
  ShowToolTipAsInfoIcon: {
    type: "checkbox",
    label: "Show Tooltip As Info Icon",
    children: [],
    alignment: "BottomDiv1",
    styleKey: "ShowToolTipAsInfoIcon",
  },
  EnableSearch: {
    type: "checkbox",
    label: "Enable Search",
    children: [],
    alignment: "BottomDiv2",
    styleKey: "EnableSearch",
  },
  AllowDuplicate: {
    type: "checkbox",
    label: "Allow Duplicates",
    children: [],
    alignment: "BottomDiv3",
    styleKey: "AllowDuplicate",
  },
  ShowTotalListview: {
    type: "checkbox",
    label: "Show Total",
    children: [],
    alignment: "BottomDiv4",
    styleKey: "ShowTotalListview",
  },
  DisplayLabelValue: {
    type: "radio",
    children: ["Display Value", "Display Label"],
    styleKey: "DisplayLabelValue",
  },
  columnCharacterSet: {
    type: "smallcombo",
    label: "Character Set",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "UPPERCASE", Value: "uppercase" },
      { Title: "LOWERCASE", Value: "lowercase" },
    ],
    alignment: "right",
    styleKey: "CharacterSet",
  },
  columnMinValue: {
    type: "smalltext",
    label: "Min Value",
    children: [],
    alignment: "right",
    styleKey: "MinValue",
    regexType: "NumericPositiveNegitive",
  },
  columnMaxValue: {
    type: "smalltext",
    label: "Max Value",
    children: [],
    alignment: "right",
    styleKey: "MaxValue",
    regexType: "NumericPositiveNegitive",
  },
  columnMaxLength: {
    type: "smalltext",
    label: "MaxLength",
    children: [],
    alignment: "right",
    styleKey: "MaxLength",
    regexType: "NumericPositive",
  },
  TableTextAreaHeight: {
    type: "smalltext",
    label: "Height",
    children: [],
    alignment: "right",
    styleKey: "TableTextAreaHeight",
    regexType: "NumericPositive",
  },
  columnCustomPattern: {
    type: "smalltext",
    label: "Custom Pattern",
    children: [],
    alignment: "right",
    styleKey: "CustomPattern",
    regexType: "",
  },
  exBox: { type: "fullwidthtext", label: "", children: [], alignment: "left" },
  ThemeIcon: {
    type: "tableThemeIcon",
    label: "",
    children: [
      { Title: "Box", label: "", children: [], Value: "box" },
      { Title: "Striped", label: "", children: [], Value: "striped" },
      { Title: "Lined", label: "", children: [], Value: "lined" },
      // {'Title':'Cards', 'label':'', 'children':[],'Value':'cards'}
    ],
    styleKey: "ControlStyle",
  },
  MultiLabelInput: { type: "toggle", label: "Label", children: [] },
  Zone: { type: "zone", label: "ZoneList" },
  PicklistInstance:{ type: "picklistinstance", label: "Picklist Instance" },
  UploadButton: { type: "uploadbtn" },
  TableButtonImageFile: {
    type: "uploadbtn",
    label: "Upload Image",
    children: [],
    alignment: "left",
    TableButtonImageFile: "",
    regexType: "Allchar",
  },
  upload: { type: "upload" },
  slider: { type: "slider" },
  input: { type: "input" },
  UploadCarouselImage: {
    type: "imageUpload",
    label: "Upload Image",
    info: "Recommended image size (1366pixels X 768pixels) Image count should not exceed (5 images)",
  },
  Inputcheckbox: { type: "inputcheckbox" },
  ListviewColumnBoxColor: {
    type: "colorpicker",
    label: "Line Color",
    children: [],
    regexType: "Fontcolor",
  },
  ListviewColumnBoxColorAdvanced: {
    type: "colorpicker",
    label: "Box Color",
    children: [],
    regexType: "Fontcolor",
  },
  ListviewRowBoxColorAdvanced: {
    type: "colorpicker",
    label: "Box Color",
    children: [],
    regexType: "Fontcolor",
  },
  ListviewHeight: {
    type: "text",
    label: "Listview Height",
    children: [],
    regexType: "NumericPositive",
  },
  ListviewColumnBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },

  ListviewRowsHeight: {
    type: "combo",
    label: "Height",
    children: [
      // { Title: "Default", Value: "36px" },
      { Title: "Compact", Value: "44px" },
      { Title: "Large", Value: "52px" },
    ],
  },

  ListviewColumnFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "italic" },
      { Title: "Normal", Value: "normal" },
    ],
  },
  ListviewColumnFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  ListviewColumnFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  ListviewColumnTextAlignment: {
    type: "combo",
    label: "Text Alignment",
    children: [
      { Title: "Left", Value: "Left" },
      { Title: "Right", Value: "Right" },
      { Title: "Center", Value: "Center" },
    ],
  },

  ListviewRowTextAlignment: {
    type: "combo",
    label: "Text Alignment",
    children: [
      { Title: "Left", Value: "Left" },
      { Title: "Right", Value: "Right" },
      { Title: "Center", Value: "Center" },
    ],
  },

  ListviewColumnFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  ListviewRowHeight: { type: "combo", label: "Height", children: [] },
  ListviewTitleFontWeightStyle: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "italic" },
      { Title: "Normal", Value: "normal" },
    ],
  },
  ListviewTitleFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  ListviewTitleFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  ListviewRowFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  ListviewTitleFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  ListviewTitle: { type: "header", label: "Listview Title" },
  AdvanceListviewTitle: { type: "header", label: "Advance Listview Title" },
  SetLayout: { type: "header", label: "Column Layout" },
  TableTitle: { type: "header", label: "Table Title" },
  ListviewColumn: { type: "header", label: "Listview Column" },
  AdvanceListviewColumn: { type: "header", label: "Advance Listview Column" },
  ListviewRows: { type: "header", label: "Listview Rows" },
  AdvanceListviewRows: { type: "header", label: "Advance Listview Rows" },
  AdditionMsg: {
    type: "msgbox",
    label:
      "Please select how you wish to add data in Listview.The configurations are different for different types.Popup is Prefarable, if columns are more than 10",
  },
  AdditionMsg2: {
    type: "msgbox",
    label:
      "Once done configuring this layout, you can select fields to show as columns in Listview. This will save time in creating columns again.",
  },
  ColumnAdditionMethod: {
    type: "additionmethods",
    children: [
      {Title:"Through Popup", Value:""},
      {Title:"Section above Listview", Value:""},
      {Title:"Section below Listview", Value:""},
    ],
  },
  ColumnAdditionMethod2: {
    type: "additionmethods",
    children: [
      { Title: "Create from scratch", Value: "" },
      // { Title: "Upload if created", Value: "" },
    ],
  },
  Title: { type: "textarea", label: "Title", children: [] },
  SectionBackground: {
    type: "colorpicker",
    label: "Section Background",
    children: [],
    regexType: "Fontcolor",
  },
  ButtonHorizontalAlignment: {
    type: "combo",
    label: "Horizontal Alignment",
    children: [
      { Title: "Center", Value: "Center" },
      { Title: "Left", Value: "flex-start" },
      { Title: "Right", Value: "flex-end" },
    ],
  },
  ButtonVerticalAlignment: {
    type: "combo",
    label: "Vertical Alignment",
    children: [
      { Title: "Center", Value: "Center" },
      { Title: "Top", Value: "flex-start" },
      { Title: "Bottom", Value: "flex-end" },
    ],
  },
  TableTitleFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

      { Title: "Normal", Value: "normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Italic", Value: "italic" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
  },
  TableTitleFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  TableTitleFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  TableBorderRadius: {
    type: "combo",
    label: "Border Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
    ],
  },
  TableBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableTitleFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableColumnFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

     { Title: "Normal", Value: "normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Italic", Value: "italic" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
  },
  TableColumnFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  TableColumnFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  TableColumnFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableColumnTextAlignment: {
    type: "combo",
    label: "Text Alignment",
    children: [
      { Title: "Left", Value: "Left" },
      { Title: "Right", Value: "Right" },
      { Title: "Center", Value: "Center" },
    ],
  },
  TableColumnBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableSelectedRowColor: {
    type: "colorpicker",
    label: "Selected Row/Cell Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableRowFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

      { Title: "Normal", Value: "normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Italic", Value: "italic" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
  },
  TableRowFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  TableRowFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  TableRowTextAlignment: {
    type: "combo",
    label: "Text Alignment",
    children: [
      { Title: "Left", Value: "Left" },
      { Title: "Right", Value: "Right" },
      { Title: "Center", Value: "Center" },
    ],
  },
  TableRowBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },
  TableRowBorderColor: {
    type: "colorpicker",
    label: "Border Color",
    children: [],
    regexType: "Fontcolor",
  },
  "Hover Effect": { type: "toggle", label: "Hover Effect" },
  "Add background behind Table": { type: "toggle", label: "Add background behind Table" },
  ValueFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "italic" },
      { Title: "Normal", Value: "normal" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
  },
  ValueFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  ValueFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "20px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  LabelFontColor: {
    type: "colorpicker",
    label: "Color",
    children: [],
    regexType: "Fontcolor",
  },
  ValueFontColor: {
    type: "colorpicker",
    label: "Color",
    children: [],
    regexType: "Fontcolor",
  },
  BatchSize: {
    type: "text",
    label: "Batch Size",
    children: [],
    regexType: "NumericPositive",
  },

  EnableCaching: { type: "toggleallow", label: "Enable Caching", children: [] },
  AllowMultipleSection: {
    type: "toggleallow",
    label: "Allow Multiple Selection",
    children: [],
  },
  AllowTyping: {
    type: "toggleallow",
    label: "Allow Typing",
    children: [],
  },
  AllowCopyingInValue: {
    type: "checkbox",
    label: "Allow Copying In Value",
    children: [],
  },

  ButtonAlignment: {
    type: "combo",
    label: "Button Alignment",
    children: [
      { Title: "Left", Value: "left" },
      { Title: "Center", Value: "center" },
      { Title: "Right", Value: "right" },
    ],
  },

  ShowTitle: { type: "toggle", label: "Show Title" },
  ShowTotal: { type: "toggle", label: "Show Total", children: [] },
  ListviewColumnHeight: {
    type: "combo",
    label: "Height",
    children: [
      // { Title: "Default", Value: "36px" },
      { Title: "Compact", Value: "44px" },
      { Title: "Large", Value: "52px" },
    ],
  },
  // 'ToggleLabel':{'type':'header', 'label':'Label','regexType' : 'Allchar'},
  // 'SpacingLeft' : {'type':'combo', 'label':'Spacing Left', 'children':[
  //     {'Title':'Small', 'Value':'36px'},
  // 	{'Title':'Medium', 'Value':'44px'},
  // 	{'Title':'Large', 'Value':'52px'}
  // ]},
  // 'SpacingRight' : {'type':'combo', 'label':'Spacing Right', 'children':[
  //     {'Title':'Small', 'Value':'36px'},
  // 	{'Title':'Medium', 'Value':'44px'},
  // 	{'Title':'Large', 'Value':'52px'}
  // ]},
  // 'SpacingTop' : {'type':'combo', 'label':'Spacing Top', 'children':[
  //     {'Title':'Small', 'Value':'36px'},
  // 	{'Title':'Medium', 'Value':'44px'},
  // 	{'Title':'Large', 'Value':'52px'}
  // ]},
  // 'SpacingBottom' : {'type':'combo', 'label':'Spacing Bottom', 'children':[
  //     {'Title':'Small', 'Value':'36px'},
  // 	{'Title':'Medium', 'Value':'44px'},
  // 	{'Title':'Large', 'Value':'52px'}
  // ]},

  SpacingLeft: {
    type: "autocomplete",
    label: "Spacing Left",
    children:   [
      { Title: "4",  Value: "4px" },
      { Title: "8",  Value: "8px" },
      { Title: "12",  Value: "12px" },
      { Title: "16",  Value: "16px" },
      { Title: "20",  Value: "20px" },
      { Title: "24",  Value: "24px" },
      { Title: "28",  Value: "28px" },
      { Title: "32",  Value: "32px" },
      { Title: "36",  Value: "36px" },
      { Title: "40",  Value: "40px" },
      { Title: "44",  Value: "44px" },
      { Title: "48",  Value: "48px" },
    ],
  },
  SpacingRight: {
    type: "autocomplete",
    label: "Spacing Right",
    children:   [
      { Title: "4",  Value: "4px" },
      { Title: "8",  Value: "8px" },
      { Title: "12",  Value: "12px" },
      { Title: "16",  Value: "16px" },
      { Title: "20",  Value: "20px" },
      { Title: "24",  Value: "24px" },
      { Title: "28",  Value: "28px" },
      { Title: "32",  Value: "32px" },
      { Title: "36",  Value: "36px" },
      { Title: "40",  Value: "40px" },
      { Title: "44",  Value: "44px" },
      { Title: "48",  Value: "48px" },
    ],
  },
  SpacingTop: {
    type: "autocomplete",
    label: "Spacing Top",
    children:    [
      { Title: "4",  Value: "4px" },
      { Title: "8",  Value: "8px" },
      { Title: "12",  Value: "12px" },
      { Title: "16",  Value: "16px" },
      { Title: "20",  Value: "20px" },
      { Title: "24",  Value: "24px" },
      { Title: "28",  Value: "28px" },
      { Title: "32",  Value: "32px" },
      { Title: "36",  Value: "36px" },
      { Title: "40",  Value: "40px" },
      { Title: "44",  Value: "44px" },
      { Title: "48",  Value: "48px" },
    ],
  },
  SpacingBottom: {
    type: "autocomplete",
    label: "Spacing Bottom",
    children:   [
      { Title: "4",  Value: "4px" },
      { Title: "8",  Value: "8px" },
      { Title: "12",  Value: "12px" },
      { Title: "16",  Value: "16px" },
      { Title: "20",  Value: "20px" },
      { Title: "24",  Value: "24px" },
      { Title: "28",  Value: "28px" },
      { Title: "32",  Value: "32px" },
      { Title: "36",  Value: "36px" },
      { Title: "40",  Value: "40px" },
      { Title: "44",  Value: "44px" },
      { Title: "48",  Value: "48px" },
    ],
  },
  InnerSpacingLeft: {
    type: "autocomplete",
    label: "Spacing Left",
    children:   [
      { Title: "4",  Value: "4px" },
      { Title: "8",  Value: "8px" },
      { Title: "12",  Value: "12px" },
      { Title: "16",  Value: "16px" },
      { Title: "20",  Value: "20px" },
      { Title: "24",  Value: "24px" },
      { Title: "28",  Value: "28px" },
      { Title: "32",  Value: "32px" },
      { Title: "36",  Value: "36px" },
      { Title: "40",  Value: "40px" },
      { Title: "44",  Value: "44px" },
      { Title: "48",  Value: "48px" },
    ],
  },
  InnerSpacingRight: {
    type: "autocomplete",
    label: "Spacing Right",
    children:   [
      { Title: "4",  Value: "4px" },
      { Title: "8",  Value: "8px" },
      { Title: "12",  Value: "12px" },
      { Title: "16",  Value: "16px" },
      { Title: "20",  Value: "20px" },
      { Title: "24",  Value: "24px" },
      { Title: "28",  Value: "28px" },
      { Title: "32",  Value: "32px" },
      { Title: "36",  Value: "36px" },
      { Title: "40",  Value: "40px" },
      { Title: "44",  Value: "44px" },
      { Title: "48",  Value: "48px" },
    ],
  },
  InnerSpacingTop: {
    type: "autocomplete",
    label: "Spacing Top",
    children:    [
      { Title: "4",  Value: "4px" },
      { Title: "8",  Value: "8px" },
      { Title: "12",  Value: "12px" },
      { Title: "16",  Value: "16px" },
      { Title: "20",  Value: "20px" },
      { Title: "24",  Value: "24px" },
      { Title: "28",  Value: "28px" },
      { Title: "32",  Value: "32px" },
      { Title: "36",  Value: "36px" },
      { Title: "40",  Value: "40px" },
      { Title: "44",  Value: "44px" },
      { Title: "48",  Value: "48px" },
    ],
  },
  InnerSpacingBottom: {
    type: "autocomplete",
    label: "Spacing Bottom",
    children:   [
      { Title: "4",  Value: "4px" },
      { Title: "8",  Value: "8px" },
      { Title: "12",  Value: "12px" },
      { Title: "16",  Value: "16px" },
      { Title: "20",  Value: "20px" },
      { Title: "24",  Value: "24px" },
      { Title: "28",  Value: "28px" },
      { Title: "32",  Value: "32px" },
      { Title: "36",  Value: "36px" },
      { Title: "40",  Value: "40px" },
      { Title: "44",  Value: "44px" },
      { Title: "48",  Value: "48px" },
    ],
  },

  SectionKeyField: {
    type: "autocomplete",
    label: "Section Key Field",
    children:   [
      { Title: "frame1",  Value: "frame1" },
      { Title: "frame2",  Value: "frame2" },
    ],
  },

  SectionKeyValue: {
    type: "text_top_bottom",
    label: "Section Key Field Value",
    children: [],
    regexType: "Allchar",
  },

  LabelSwitchAlignment: {
    type: "combo",
    label: "Toggle Alignment",
    children: [
      { Title: "Top Down", Value: "TopDown" },
      { Title: "Left Right", Value: "LeftRight" },
      { Title: "Right Left", Value: "ToggleLabel"}
    ],
  },
  ActiveStateBackgroundColor: {
    type: "colorpicker",
    label: "Toggle Color",
    children: [],
    regexType: "Fontcolor",
  },
  ToggleStyle: {
    type: "stylemethods",
    label: "ToggleStyle",
    children: [
      { Title: "", Value: "" },
      { Title: "", Value: "" },
    ],
  },
  ToggleLabel: {
    type: "fullwidthtextinput",
    label: "Label",
    regexType: "Allchar",
  },
  ToggleLabelHeader: { type: "header", label: "Label" },
  ToggleMapping: {
    type: "fullwidthtextinput",
    label: "Mapping",
    regexType: "",
  },
  UserDefinedControlId: {
    type: "fullwidthtextinput",
    label: "User defined ID",
    regexType: "CustomControlRid",
  },
  TableMapping: { type: "fullwidthtextinput", label: "Mapping", regexType: "" },
  TableLabel: {
    type: "fullwidthtextinput",
    label: "Table Label",
    regexType: "Allchar",
  },
  AdvanceListviewLabel: {
    type: "fullwidthtextinput",
    label: "Advance Listview Label",
    regexType: "Allchar",
  },
  ListviewLabel: {
    type: "fullwidthtextinput",
    label: "Listview Label",
    regexType: "Allchar",
  },

  UserDefinedControlIdCheckbox: {
    type: "text_top_bottom",
    label: "User defined ID",
    regexType: "CustomControlRid",
  },

  SourceURL: { type: "textareaurl", label: "Source URL" },
  FullScreenView: { type: "toggle", label: "Full Screen View" },

  Width: { type: "text", label: "Width" },
  Height: { type: "text", label: "Height", regexType: "NumericPositive" },
  HeightText: { type: "height", label: "Height", regexType: "NumericPositive" },
  MinimumValue: {
    type: "text",
    label: "Minimum Value",
    toolTip: "Minimum Value Tooltip Content",
    regexType: "NumericPositiveNegitive",
  },
  MaximumValue: {
    type: "text",
    label: "Maximum Value",
    toolTip: "Maximum Value Tooltip Content",
    regexType: "NumericPositiveNegitive",
  },
  DefaultValueSlider: {
    type: "text",
    label: "Default Value",
    toolTip: "Default Value Slider Tooltip Content",
    regexType: "NumericPositiveNegitive",
  },
  // 'DefaultUnit' : {'type':'text', 'label':'Default Value'},
  DefaultUnit: {
    type: "combo",
    label: "Default Unit",
    toolTip: "Default Unit Tooltip Content",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Dollars", Value: "Dollars" },
      { Title: "Indian", Value: "Indian" },
    ],
  },
  SetBreakpoint: {
    type: "text",
    label: "Set Breakpoint",
    toolTip: "Set Breakpoint Tooltip Content",
    regexType: "NumericPositive",
  },

  ToggleStates: {
    type: "combo",
    label: "Toggle States",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Yes/No", Value: "Yes/No" },
      { Title: "On/Off", Value: "On/Off" },
      { Title: "Custom State", Value: "CustomState" },
    ],
  },
  ShowToggleStateBesideSwitch: {
    type: "toggle",
    label: "Display Toggle State Beside Switch",
  },
  ParagraphAlignment: {
    type: "combo",
    label: "Paragraph Alignment",
    children: [
      { Title: "Left", Value: "left" },
      { Title: "Right", Value: "right" },
    ],
  },

  DatePickerLabel: {
    type: "text",
    label: "Label",
    children: [],
    regexType: "Allchar",
  },
  DatePickerType: { type: "label", label: "Type", children: [] },
  AllowManualInput: { type: "toggle", label: "Allow Manual Input Only" },
  PickerType: { type: "icon", label: "DatePicker Type", children: [] },
  // 'DateFormatTable':{'type':'combodateformat','alignment':'right','styleKey':'DateFormatTable', 'label':'Date Format', 'children':[
  //     {'Title':'DD/MM/YYYY', 'Value':'1'},
  //     {'Title':'MM/DD/YYYY', 'Value':'2'},
  //     {'Title':'YYYY/MM/DD', 'Value':'3'},
  //     {'Title':'DD/MMM/YYYY', 'Value':'4'},
  //     {'Title':'DD/MM/YYYY, HH:MM', 'Value':'5'},
  //     {'Title':'MM/DD/YYYY, HH:MM',  'Value':'6'},
  //     {'Title':'YYYY/MM/DD, HH:MM','Value':'7'},
  //     {'Title':'DD/MMM/YYYY, HH:MM','Value':'8'}
  // ]},
  DateFormat: {
    type: "combodateformat",
    alignment: "left",
    styleKey: "DateFormat",
    label: "Date Format",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "DD/MM/YYYY", Value: "1" },
      { Title: "MM/DD/YYYY", Value: "2" },
      { Title: "YYYY/MM/DD", Value: "3" },
      { Title: "DD/MMM/YYYY", Value: "4" },
      { Title: "DD/MM/YYYY, HH:MM", Value: "5" },
      { Title: "MM/DD/YYYY, HH:MM", Value: "6" },
      { Title: "YYYY/MM/DD, HH:MM", Value: "7" },
      { Title: "DD/MMM/YYYY, HH:MM", Value: "8" },
    ],
  },
  LabelInputAlignment: {
    type: "combo",
    label: "Label-Value Alignment",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Top-Down", Value: "Top-Down" },
      { Title: "Left-Right", Value: "Left-Right" },
    ],
  },
  LabelHeader: { type: "header", label: "Label" },

  SliderHeader: { type: "headerslider", label: "Slider" },
  LabelWidth: { type: "header", label: "Width" },
  ValueHeader: { type: "header", label: "Value" },
  DefaultStateLabel: { type: "label", label: "Default State", children: [] },
  DefaultValue: { type: "inputradio" },
  ToolTip: {
    type: "textarea",
    label: "Label Description",
    children: [],
    regexType: "Allchar",
  },
  // 'CustomId':{'type':'text', 'label':'User defined ID', 'children':[],'regexType' : 'CustomControlRid'},
  ControlStyle: { type: "icon", label: "DatePicker Style", children: [] },
  EditOption: { type: "toggle", label: "Previous/Next while Edit" },
  OverlayBackground: {
    type: "colorpicker",
    label: "Overlay Background",
    children: [],
    regexType: "Fontcolor",
  },
  OverlayButtonAlignment: {
    type: "combo",
    label: "Button Alignment",
    children: [
      { Title: "Bottom-Left", Value: "left" },
      { Title: "Bottom-Right", Value: "right" },
    ],
  },
  ListviewOverlayTitle: { type: "textarea", label: "Title", children: [] },
  ShowCharacterCount: { type: "toggle", label: "Show Character Count(0/200)" },

  w: {
    type: "combo",
    label: "Column Width",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: 1, Value: 1 },
      { Title: 2, Value: 2 },
      { Title: 3, Value: 3 },
      { Title: 4, Value: 4 },
      { Title: 5, Value: 5 },
      { Title: 6, Value: 6 },
      { Title: 7, Value: 7 },
      { Title: 8, Value: 8 },
      { Title: 9, Value: 9 },
      { Title: 10, Value: 10 },
      { Title: 11, Value: 11 },
      { Title: 12, Value: 12 },
    ],
  },
  sm: {
    type: "combo",
    label: "Column Width (Tablet)",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: 1, Value: 1 },
      { Title: 2, Value: 2 },
      { Title: 3, Value: 3 },
      { Title: 4, Value: 4 },
      { Title: 5, Value: 5 },
      { Title: 6, Value: 6 },
      { Title: 7, Value: 7 },
      { Title: 8, Value: 8 },
      { Title: 9, Value: 9 },
      { Title: 10, Value: 10 },
      { Title: 11, Value: 11 },
      { Title: 12, Value: 12 },
    ],
  },
  xs: {
    type: "combo",
    label: "Column Width (Mobile)",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: 1, Value: 1 },
      { Title: 2, Value: 2 },
      { Title: 3, Value: 3 },
      { Title: 4, Value: 4 },
      { Title: 5, Value: 5 },
      { Title: 6, Value: 6 },
      { Title: 7, Value: 7 },
      { Title: 8, Value: 8 },
      { Title: 9, Value: 9 },
      { Title: 10, Value: 10 },
      { Title: 11, Value: 11 },
      { Title: 12, Value: 12 },
    ],
  },
  longinput1: { regexType: "Allchar" },
  label: { regexType: "Allchar" },
  Caption: { regexType: "Allchar" },
  width: { regexType: "NumericPositive" },
  RichtextEditorMapping: {
    type: "fullwidthtextinput",
    label: "Mapping",
    regexType: "",
  },
  RichtextEditorLabelHeader: { type: "header", label: "Label" },
  MaxHeight: {
    type: "maxHeightText",
    label: "Max-Height",
    children: [],
    regexType: "NumericPositive",
  },
  UploadImagesCarousel: {
    type: "imageUpload",
    label: "Upload Image",
    info: "Recomended image size (1366pixels X 768pixels) Image count should not exceed (5 images)",
  },
  AllowAutoScroll: { type: "toggle", label: "Allow Auto Scroll" },
  ImageCarouselHeight: {
    type: "text",
    label: "Image Height",
    unit: "px",
    children: [],
    regexType: "NumericPositive",
  },
  AutoplaySpeed: {
    type: "text",
    label: "Autoplay Speed",
    unit: "ms",
    children: [],
    regexType: "NumericPositive",
  },
  Speed: {
    type: "text",
    label: "Speed",
    unit: "ms",
    children: [],
    regexType: "NumericPositive",
  },
  DocumentListLabelFontWeightStyle: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

      { Title: "Select", Value: "Select" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "Italic" },
      { Title: "Normal", Value: "Normal" },
    ],
  },
  DocumentListLabelFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },

  DocumentListLabelFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  DocumentListLabelFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  DocumentTypeLabelFontWeightStyle: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

      { Title: "Select", Value: "Select" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "Italic" },
      { Title: "Normal", Value: "Normal" },
    ],
  },
  DocumentTypeLabelFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  DocumentTypeLabel: { type: "header", label: "Document Type Label" },
  DocumentTypeLabelFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  DocumentButtonFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
    alignment: "left",
    styleKey: "FontFamily",
  },
  DocumentButtonFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
    ],
  },
  DocumentButtonFontStyle: {
    type: "combo",
    label: "Font-style",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "Normal", Value: "Normal" },
      { Title: "Italic", Value: "italic" },
      { Title: "Bold", Value: "bold" },
      //   { Title: "Oblique", Value: "oblique" },
    ],
  },
  DocumentButtonBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "left",
    styleKey: "BackgroundColor",
  },
  DocumentButtonBulkBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "left",
    styleKey: "BackgroundColor",
  },
  DocumentButtonFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "left",
    styleKey: "FontColor",
  },
  DocumentButtonBulkFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "left",
    styleKey: "FontColor",
  },
  DocumentButtonCornerRadius: {
    type: "combo",
    label: "Corner Radius",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
      { Title: "16", Value: "16px" },
    ],
    alignment: "left",
    styleKey: "CornerRadius",
  },
  DocumentLabel: {
    type: "text_top_bottom",
    label: "Label",
    children: [],
    regexType: "Allchar",
  },
  DocumentDescription: {
    type: "textarea",
    label: "Description",
    children: [],
    regexType: "Allchar",
  },
  AllowAutoCreation: {
    type: "toggleselect",
    label: "Allow auto creation of document table",
    label2: "Select Parent Table for docList",
  },
  DocumentTypeLabelFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  DocumentListLabel: { type: "header", label: "Document List Label" },
  UploadButtonTypeHeader: { type: "header", label: "Upload Button Type" },
  BulkUploadButtonHeader: { type: "header", label: "Bulk Upload Button" },
  BulkUploadButton: { type: "toggle", label: "Show Bulk Upload Button" },
  DocumentTypeHeader: {
    type: "documenttype",
    details: {
      DocumentName: {
        type: "text_top_bottom",
        label: "Document Type Label",
        children: [],
        regexType: "Allchar",
      },
      Mandatory: { type: "toggle", label: "Mandatory" },
      // 'DocTypeDescription':{'type':'textarea', 'label':'Description', 'children':[],
      //                 'regexType' : 'Allchar'},
      SupportedDocumentsinDocType: {
        type: "multiselectgroup",
        label: "Supported Documents in Doc Type",
        children: {
          DOCS: [
            { Title: "Aadhar Card", value: "Aadhar Card" },
            { Title: "PAN Card", value: "PAN Card" },
            { Title: "Passport", value: "Passport" },
          ],
        },
      },
      DocTypeIcon: { type: "imageUpload", label: "Document Type Icon" },
      // 'AllowedFileTypes' : {'type':'combo', 'label':'Allowed File Types', 'children':[
      //     {'Title':'JPG', 'Value':'jpg'},
      //     {'Title':'PNG', 'Value':'png'},
      //     {'Title':'GIF', 'Value':'gif'},
      //     {'Title':'PDF', 'Value':'pdf'},
      //     {'Title':'SVG', 'Value':'svg'},
      //     {'Title':'TXT', 'Value':'txt'}]},
      AllowedFileTypes: {
        type: "multiselectgroup",
        label: "Allowed File Types",
        children: {
          IMAGE: [
            { Title: "JPG", value: "JPG" },
            { Title: "JPEG", value: "JPEG" },
            { Title: "TIFF", value: "TIFF" },
            { Title: "PNG", value: "PNG" },
            { Title: "GIF", value: "GIF" },
          ],
          DOCUMENT: [
            { Title: "PDF", value: "PDF" },
            { Title: "TXT", value: "TXT" },
            { Title: "DOC", value: "DOC" },
            { Title: "SVG", value: "SVG" },
          ],
        },
      },
      MaxSizeOfDoc: {
        type: "text",
        label: "Max size of Documents",
        children: ["KB", "MB"],
        regexType: "NumericPositive",
      },
      showMaxSize: {
        type: "toggle",
        label:"Show max size on UI"
      },
      DimensionsOfImage: {
        type: "buttongroup",
        label: "Dimensions of Image",
        children: ["PX"],
        regexType: "NumericPositive",
      },
      UploadOption: {
        type: "select",
        label: "Documents Upload Mode",
        children: [
          { Title: "Through Browse", Value: "Through Browse" },
          { Title: "Through Camera", Value: "Through Camera" },
          { Title: "Both", Value: "Both" },
        ],
      },
      AllowMultipleUploads: { type: "toggle", label: "Allow Multiple Uploads" },
      allow_comment: { type: "toggle", label: "Enable Comments" },
      mandatory_comments: { type: "toggle", label: "Mandatory on Comments" },
      "Add Document Type": {
        type: "+ Add Document Type",
        label: "Add Document Type",
      },
    },
  },
  DocumentTypes: { type: "header", label: "Document Types" },
  DocumentName: {
    type: "text_top_bottom",
    label: "Document Type Label",
    children: [],
    regexType: "Allchar",
  },
  Mandatory: { type: "toggle", label: "Mandatory" },
  DocTypeIcon: { type: "imageUpload", label: "Document Type Icon" },
  DocumentIcon: { type: "imageUpload", label: "Upload Icon" },
  SupportedDocumentsinDocType: {
    type: "multiselectgroup",
    label: "Supported Documents in Doc Type",
    button: "+ Add New",
    children: {
      DOCS: [
        { Title: "Aadhar Card", value: "Aadhar Card" },
        { Title: "PAN Card", value: "PAN Card" },
        { Title: "Passport", value: "Passport" },
        { Title: "Voter ID", value: "Voter ID" },
        { Title: "Birth Certificate", value: "Birth Certificate" },
      ],
    },
  },
  // 'DocTypeDescription':{'type':'textarea', 'label':'Control Description', 'children':[],
  //                 'regexType' : 'Allchar'},
  // 'AllowedFileTypes' : {'type':'combo', 'label':'Allowed File Types', 'children':[
  //     {'Title':'JPG', 'Value':'jpg'},
  //     {'Title':'PNG', 'Value':'png'},
  //     {'Title':'GIF', 'Value':'gif'},
  //     {'Title':'PDF', 'Value':'pdf'},
  //     {'Title':'SVG', 'Value':'svg'},
  //     {'Title':'TXT', 'Value':'txt'}]},
  AllowedFileTypes: {
    type: "multiselectgroup",
    label: "Allowed File Types",
    children: {
      IMAGE: [
        { Title: "JPG", value: "JPG" },
        { Title: "JPEG", value: "JPEG" },
        { Title: "TIFF", value: "TIFF" },
        { Title: "PNG", value: "PNG" },
        { Title: "GIF", value: "GIF" },
      ],
      DOCUMENT: [
        { Title: "PDF", value: "PDF" },
        { Title: "TXT", value: "TXT" },
        { Title: "DOC", value: "DOC" },
        { Title: "SVG", value: "SVG" },
      ],
    },
  },
  MaxSizeOfDoc: {
    type: "text",
    label: "Max size of Documents",
    unit: "px",
    children: ["KB", "MB"],
    regexType: "NumericPositive",
  },
  showMaxSize: {
    type: "toggle",
    label:"Show max size on UI"
  },
  DimensionsOfImage: {
    type: "buttongroup",
    label: "Dimensions of Image",
    children: ["PX"],
    regexType: "NumericPositive",
  },
  AllowMultipleUploads: { type: "toggle", label: "Allow Multiple Uploads" },
  allow_comment: { type: "toggle", label: "Enable Comments" },
  mandatory_comments: { type: "toggle", label: "Mandatory on Comments" },
  "Add Document Type": {
    type: "+ Add Document Type",
    label: "Add Document Type",
  },

  // "NoOfDocumentTypes" : {'type':'text_top_bottom', 'label':'No of Document Types', 'children':[]},
  // UploadOption: {
  //   type: "select",
  //   label: "Documents Upload Mode",
  //   children: [
  //     { Title: "Through Browse", Value: "Through Browse" },
  //     { Title: "Through Camera", Value: "Through Camera" },
  //     { Title: "Both", Value: "Both" },
  //   ],
  // },
  UploadOption: {
    type: "radio",
    label: "Documents Upload Mode",
    children: [
      { Title: "Through Browse", Value: "1" },
      { Title: "Through Camera", Value: "2" },
      { Title: "Both", Value: "3" },
    ],
  },
  GridTileViewType: {
    type: "radio",
    label: "",
    children: [
      { Title: "Vertically Stacked Tiles", Value: "vertical" },
      { Title: "Horizontally Stacked Tiles", Value: "horizontal" },
    ],
  },
  AddDocumentType: {
    type: "fullWidthInputButton",
    label: "Add Document Type",
  },
  StylesOption: {
    type: "styleoptions",
    label: "Style",
    subKey: "DocTypeStyle",
  },
  NoOfDocumentTypes: {
    type: "text_top_bottom",
    label: "No of Document Types",
    children: [],
  },
  DocumentsUploadMode: {
    type: "radio",
    label: "Documents Upload Mode",
    children: [
      { Title: "Through Browse", Value: "ThroughBrowse" },
      { Title: "Through Camera", Value: "ThroughCamera" },
      { Title: "Both", Value: "ThroughBrowseThroughCamera" },
    ],
  },
  UploadCarousel: {
    type: "carouselupload",
    label: "Upload Image",
    info: "Recomended image size (1366pixels X 768pixels) Image count should not exceed (5 images)",
  },

  AllowAutoScrol: { type: "toggle", label: "Allow Auto Scroll" },
  ButtonsType: {
    type: "button",
    label: "Upload Button Type",
    children: [
      { Title: "Primary", Value: "2" },
      { Title: "Secondary", Value: "3" },
      { Title: "Text Button", Value: "1" },
    ],
  },

  TileCornerRadius: {
    type: "combo",
    label: "Corner Radius",
    children: [
      { Title: "Select", Value: "Select" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
      { Title: "16", Value: "16px" },
    ],
  },

  TitleFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },

  TitleFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },

  TitleFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "italic" },
      { Title: "Normal", Value: "normal" },
    ],
  },

  TitleFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },

  DescriptionFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },

  DescriptionFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },

  DescriptionFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "italic" },
      { Title: "Normal", Value: "normal" },
    ],
  },

  DescriptionFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },

  PointsFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },

  PointsFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      // {'Title':'17','style':{fontSize:"12px"}, 'Value':'17px'},
      // {'Title':'18','style':{fontSize:"12px"}, 'Value':'18px'},
      // {'Title':'19','style':{fontSize:"12px"}, 'Value':'19px'},
      // {'Title':'20','style':{fontSize:"12px"}, 'Value':'20px'},
      // {'Title':'21','style':{fontSize:"12px"}, 'Value':'21px'},
      // {'Title':'22','style':{fontSize:"12px"}, 'Value':'22px'},
      // {'Title':'23','style':{fontSize:"12px"}, 'Value':'23px'},
      // {'Title':'24','style':{fontSize:"12px"}, 'Value':'24px'},
      // {'Title':'25','style':{fontSize:"12px"}, 'Value':'25px'},
      // {'Title':'26','style':{fontSize:"12px"}, 'Value':'26px'},
      // {'Title':'27','style':{fontSize:"12px"}, 'Value':'27px'},
      // {'Title':'28','style':{fontSize:"12px"}, 'Value':'28px'},
      // {'Title':'29','style':{fontSize:"12px"}, 'Value':'29px'},
      // {'Title':'30','style':{fontSize:"12px"}, 'Value':'30px'}
    ],
  },

  PointsFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      // {'Title':'Normal', 'Value':'Normal'},
      // {'Title':'Bold', 'Value':'Bold'},
      // {'Title':'Bolder', 'Value':'bolder'},
      // {'Title':'Lighter', 'Value':'lighter'},
      // {'Title':'Initial', 'Value':'initial'}

      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Italic", Value: "italic" },
      { Title: "Normal", Value: "normal" },
    ],
  },

  PointsFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },

  ButtonFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      {'Title':'Select', 'style':{fontFamily:""}, 'Value':'Select'},
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
    alignment: "left",
    styleKey: "FontFamily",
  },

  ButtonFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "12px" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
    alignment: "right",
    styleKey: "FontSize",
  },

  ButtonFontStyle: { 
    type: "combo",
    label: "Font-style",
    children: [
      { Title: "Normal", Value: "Normal" },
      { Title: "Italic", Value: "italic" },
      { Title: "Bold", Value: "bold" },
      {Title:"SemiBold",Value:"600"},
      { Title: "Bold Italic", Value: "Bold Italic" },
      // {'Title':'Oblique', 'Value':'oblique'}
    ],
  },

  ButtonBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "BackgroundColor",
  },

  ButtonFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
    alignment: "right",
    styleKey: "FontColor",
  },

  ButtonCornerRadius: {
    type: "combo",
    label: "Corner Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
      { Title: "11", Value: "11px" },
      { Title: "12", Value: "12px" },
      { Title: "13", Value: "13px" },
      { Title: "14", Value: "14px" },
      { Title: "15", Value: "15px" },
      { Title: "16", Value: "16px" },
    ],
    alignment: "right",
    styleKey: "CornerRadius",
  },

  HrTitleTag: { type: "hr", label: "" },
  HrPointsTag: { type: "hr", label: "" },
  HrDescriptionTag: { type: "hr", label: "" },
  HrImageTag: { type: "hr", label: "" },
  HrButtonTag: { type: "hr", label: "" },

  ImageHeader: { type: "header", label: "Image" },
  TitleHeader: { type: "header", label: "Title" },
  DescriptionHeader: { type: "header", label: "Description" },
  PointsHeader: { type: "header", label: "Points" },
  ButtonsHeader: { type: "header", label: "Buttons" },

  PointsStyle: {
    type: "combo",
    label: "Points Style",
    children: [
      { Title: "Dots", Value: "bullet" },
      { Title: "Tick", Value: "tick" },
      { Title: "Arrows", Value: "arrow" },
    ],
  },
  NoOfTiles: { type: "text", label: "No Of Tiles", children: [] },
  NoOfTilesQuick: { type: "texttile", label: "No Of Tiles", children: [] },
  TileBackgroundColor: {
    type: "colorpicker",
    label: "Tile Background Color",
    children: [],
  },
  LinkTextColor: {
    type: "colorpicker",
    label: "Link Text Color",
    children: [],
  },
  TileBorderColor: {
    type: "colorpicker",
    label: "Tile Border Color",
    children: [],
  },
  AddShadowToTiles: { type: "toggle", label: "Add Shadow to tiles" },

  ImageFitting: {
    type: "imagefittingmethod",
    children: [
      { Title: "Default", Value: "" },
      { Title: "Stretch to tile width", Value: "" },
    ],
  },

  TileSelectionType: {
    type: "tileselectionmethod",
    label: "Tile Selection Type",
    children: [
      { Title: "Single Select", Value: "" },
      { Title: "Multi Select", Value: "" },
    ],
  },

  TileType: { type: "tileicon", label: "Tile Type", children: [] },

  TileStyle: { type: "tilestyle", label: "", children: [] },

  TileContents: { type: "tilecontent", label: "Tile Contents", children: [] },

  AllTiles: { type: "alltiles", label: "", children: [], regexType: "Allchar" },

  customizedAlertConfirmationData: {
    open: false,
    showConfirm: "showconformationDialogBox",
    alertContentKey: "DeleteConfirmationContent",
    alertTitleKey: "DeleteConfirmationTitle",
    Button1Key: "CancelButton",
    Button2Key: "DeleteButton",
  },
  customizedAlertNotificationData: {
    open: false,
    showConfirm: "showNotification",
    alertType: "error",
    alertContentKey: "SaveFormFailureMessage",
    autoHideDuration: 6000,
  },
  // AllTiles: { type: "alltiles", label: "", children: [], regexType: "Allchar" },
  optionAdditionType: {
    label: "Option Addition",
    type: "optionadditiontype",
    children: [{ Title: "Create manually" }, { Title: "Fetch from database" }],
  },
  optionAdditionTypePicklist: {
    label: "Option Addition",
    type: "optionadditiontype",
    children: [
      // {'Title':'Create manually'},
      // {'Title':'Fetch from database'}
    ],
  },

  // 'NextButtonStyle': {'type':'combo', 'label':'Button Style', 'children':[
  //     {'Title':'Primary', 'Value':'Primary'},
  //     {'Title':'Secondary', 'Value':'Secondary'}
  //     ]},

  // 'BackButtonStyle': {'type':'combo', 'label':'Button Style', 'children':[
  //     {'Title':'Primary', 'Value':'Primary'},
  //     {'Title':'Secondary', 'Value':'Secondary'}
  //  ]},

  //  'SaveAndExitButtonStyle': {'type':'combo', 'label':'Button Style', 'children':[
  //     {'Title':'Primary', 'Value':'Primary'},
  //     {'Title':'Secondary', 'Value':'Secondary'}
  //     ]},

  // 'CancelButtonStyle': {'type':'combo', 'label':'Button Style', 'children':[
  //     {'Title':'Primary', 'Value':'Primary'},
  //     {'Title':'Secondary', 'Value':'Secondary'}
  //  ]},

  //  'NextButtonLabel':{'type':'text', 'label':'Button Label', 'children':[],'alignment':'right',
  //  'regexType' : ''},

  //  'BackButtonLabel':{'type':'text', 'label':'Button Label', 'children':[],'alignment':'right',
  //  'regexType' : ''},

  //  'SaveAndExitButtonLabel':{'type':'text', 'label':'Button Label', 'children':[],'alignment':'right',
  //  'regexType' : ''},

  //  'CancelButtonLabel':{'type':'text', 'label':'Button Label', 'children':[],'alignment':'right',
  //  'regexType' : ''},

  //  'NextButtonTag' :  {'type':'header', 'label':'Next Button'},

  //  'BackButtonTag' :  {'type':'header', 'label':'Back Button'},

  //  'SaveAndExitButtonTag' :  {'type':'header', 'label':'Save & Exit Button'},

  //  'CancelButtonTag' :  {'type':'header', 'label':'Cancel Button'},

  //  'TabsLabelTag' :  {'type':'header', 'label':'Tabs Label'},

  //  'ActiveTabTag' :  {'type':'header', 'label':'Active Tab'},

  //  'InActiveTag' :  {'type':'header', 'label':'Inactive Tab'},

  //  'AddStepButton' : {'type':'button', 'label':''},

  //  'allTabs' : {'type':'tabs', 'label':''}

  groupOfControlsHeader1: {
    children: [
      { elemType: "image" },
      {
        elemType: "label",
        style: { color: "#3E3E3E" },
        text: "Finacle Reference Number 166616788",
      },
      {
        elemType: "label",
        style: { color: "#3E3E3E" },
        text: "Registration Number TR9876",
      },
      {
        elemType: "label",
        style: { color: "#3E3E3E" },
        text: "Unique Reference Number 9474884894",
      },
      {
        elemType: "label",
        style: { color: "#3E3E3E" },
        text: "Workstep Name Draft",
      },
    ],
  },

  groupOfControlsHeader2: {
    children: [
      {
        elemType: "label",
        style: { color: "#3E3E3E", fontSize: "16px" },
        text: "Legal Counsel Appointment",
      },
      { elemType: "button", style: { buttonType: "Primary" }, text: "Delete" },
      { elemType: "button", style: { buttonType: "Primary" }, text: "Save" },
      {
        elemType: "button",
        style: { buttonType: "Secondary" },
        text: "Submit",
      },
    ],
  },

  groupOfControlsHeader3: {
    children: [
      { elemType: "image" },
      { elemType: "label" },
      { elemType: "label" },
      { elemType: "label" },
      { elemType: "label" },
    ],
  },

  groupOfControlsHeader4: {
    children: [
      { elemType: "image" },
      {
        elemType: "label",
        style: { color: "#3A3A3A" },
        text: "Schedule Appointment",
      },
      { elemType: "label", style: { color: "#3A3A3A" }, text: "Call us" },
      { elemType: "label", style: { color: "#3A3A3A" }, text: "Learn more" },
    ],
  },

  groupOfControlsFooter1: {
    children: [
      {
        elemType: "label",
        style: { color: "#3A3A3A" },
        text: "Copyright 2020. The Landmark Trust Banking Corporation Limited. All rights reserved.",
      },
      { elemType: "label", text: "Disclaimer" },
      { elemType: "label", text: "Privacy Statement" },
      { elemType: "label", text: "Terms and Conditions" },
    ],
  },

  groupOfControlsFooter2: {
    children: [
      { elemType: "label", style: { color: "#FFFFFF" }, text: "Disclaimer" },
      {
        elemType: "label",
        style: { color: "#FFFFFF" },
        text: "Privacy Statement",
      },
      {
        elemType: "label",
        style: { color: "#FFFFFF" },
        text: "Terms and Conditions",
      },
      {
        elemType: "label",
        style: { color: "#FFFFFF" },
        text: "Regulatory Disclosures",
      },
      { elemType: "label", style: { color: "#FFFFFF" }, text: "Site Terms" },
    ],
  },

  groupOfControlsFooter3: {
    children: [
      { elemType: "image" },
      {
        elemType: "label",
        style: { color: "#3A3A3A" },
        text: "Copyright 2020. The Landmark Trust Banking Corporation Limited. All rights reserved. (India) Limited (Company Registration No. 201420624K) 2018 v 6. The Landmark Trust Banking Corporation Limited",
      },
      { elemType: "label", text: "Disclaimer" },
      { elemType: "label", text: "Privacy Statement" },
      { elemType: "label", text: "Terms and Conditions" },
    ],
  },

  groupOfControlsBody1: {
    children: [
      { elemType: "image" },
      { elemType: "label" },
      { elemType: "label" },
      { elemType: "label" },
      { elemType: "label" },
    ],
  },
  groupOfControlsBody2: {
    children: [
      { elemType: "image" },
      { elemType: "label" },
      { elemType: "label" },
      { elemType: "label" },
      { elemType: "label" },
    ],
  },
  groupOfControlsBody3: {
    children: [
      { elemType: "image" },
      { elemType: "label" },
      { elemType: "label" },
      { elemType: "label" },
      { elemType: "label" },
    ],
  },

  NextButtonLabel: {
    type: "textarea",
    label: "Button Label",
    regexType: "Allchar",
  },
  NextButtonsType: {
    type: "button",
    label: "Button Type",
    children: [
      { Title: "Primary", Value: "Primary" },
      { Title: "Secondary", Value: "Secondary" },
      { Title: "Text Button", Value: "Text Button" },
    ],
  },
  NextButtonFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bolder", Value: "bolder" },
      { Title: "Lighter", Value: "lighter" },
      { Title: "Initial", Value: "initial" },
    ],
  },
  NextButtonFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  NextButtonFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  NextButtonFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  NextButtonBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },

  SaveExitButtonLabel: {
    type: "textarea",
    label: "Button Label",
    regexType: "Allchar",
  },
  SaveExitButtonsType: {
    type: "button",
    label: "Button Type",
    children: [
      { Title: "Primary", Value: "Primary" },
      { Title: "Secondary", Value: "Secondary" },
      { Title: "Text Button", Value: "Text Button" },
    ],
  },
  SaveExitButtonFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bolder", Value: "bolder" },
      { Title: "Lighter", Value: "lighter" },
      { Title: "Initial", Value: "initial" },
    ],
  },
  SaveExitButtonFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  SaveExitButtonFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  SaveExitButtonFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  SaveExitButtonBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },

  SaveNextButtonLabel: {
    type: "textarea",
    label: "Button Label",
    regexType: "Allchar",
  },
  SaveNextButtonsType: {
    type: "button",
    label: "Button Type",
    children: [
      { Title: "Primary", Value: "Primary" },
      { Title: "Secondary", Value: "Secondary" },
      { Title: "Text Button", Value: "Text Button" },
    ],
  },
  SaveNextButtonFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bolder", Value: "bolder" },
      { Title: "Lighter", Value: "lighter" },
      { Title: "Initial", Value: "initial" },
    ],
  },
  SaveNextButtonFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  SaveNextButtonFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  SaveNextButtonFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  SaveNextButtonBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },

  BackButtonLabel: {
    type: "textarea",
    label: "Button Label",
    regexType: "Allchar",
  },
  BackButtonsType: {
    type: "button",
    label: "Button Type",
    children: [
      { Title: "Primary", Value: "Primary" },
      { Title: "Secondary", Value: "Secondary" },
      { Title: "Text Button", Value: "Text Button" },
    ],
  },
  BackButtonFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bolder", Value: "bolder" },
      { Title: "Lighter", Value: "lighter" },
      { Title: "Initial", Value: "initial" },
    ],
  },
  BackButtonFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  BackButtonFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  BackButtonFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  BackButtonBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },

  CancelButtonLabel: {
    type: "textarea",
    label: "Button Label",
    regexType: "Allchar",
  },
  CancelButtonsType: {
    type: "button",
    label: "Button Type",
    children: [
      { Title: "Primary", Value: "Primary" },
      { Title: "Secondary", Value: "Secondary" },
      { Title: "Text Button", Value: "Text Button" },
    ],
  },
  CancelButtonFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      { Title: "Normal", Value: "Normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bolder", Value: "bolder" },
      { Title: "Lighter", Value: "lighter" },
      { Title: "Initial", Value: "initial" },
    ],
  },
  CancelButtonFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  CancelButtonFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  CancelButtonFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  CancelButtonBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },
  PrimaryButtonFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      { Title: "Normal", Value: "normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Italic", Value: "italic" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
  },
  PrimaryButtonFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      // { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  PrimaryButtonFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      // { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  PrimaryButtonFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  PrimaryButtonBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },
  PrimaryButtonBorderColor: {
    type: "colorpicker",
    label: "Border Color",
    children: [],
    regexType: "Fontcolor",
  },
  PrimaryButtonBorderWidth: {
    type: "combo",
    label: "Border Width",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
    ],
  },

  PrimaryButtonBorderRadius: {
    type: "combo",
    label: "Border Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
    ],
  },
  primaryBorderColor: {
    type: "colorpicker",
    label: "Border Color",
    children: [],
    regexType: "Fontcolor",
  },
  primaryBorderWidth: {
    type: "combo",
    label: "Border Width",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
    ],
  },

  primaryBorderRadius: {
    type: "combo",
    label: "Border Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
    ],
  },
  SecondaryButtonFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
     { Title: "Normal", Value: "normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Italic", Value: "italic" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
  },
  SecondaryButtonFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      // { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  SecondaryButtonFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      // { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  SecondaryButtonFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  SecondaryButtonBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },
  SecondaryButtonBorderColor: {
    type: "colorpicker",
    label: "Border Color",
    children: [],
    regexType: "Fontcolor",
  },
  SecondaryButtonBorderWidth: {
    type: "combo",
    label: "Border Width",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
    ],
  },

  SecondaryButtonBorderRadius: {
    type: "combo",
    label: "Border Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
    ],
  },
  secondaryBorderWidth: {
    type: "combo",
    label: "Border Width",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
    ],
  },

  secondaryBorderRadius: {
    type: "combo",
    label: "Border Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
    ],
  },
  TextButtonFontWeight: {
    type: "combo",
    label: "Font Weight",
    children: [
      { Title: "Normal", Value: "normal" },
      { Title: "Bold", Value: "Bold" },
      { Title: "Bold Italic", Value: "Bold Italic" },
      { Title: "Italic", Value: "italic" },
       { Title: "Regular", Value: "Regular" },
    { Title: "Regular Italic", Value: "Regular Italic" },
      { Title: "Light", Value: "Light" },
    { Title: "Light Italic", Value: "Light Italic" },
     { Title: "Semibold Italic", Value: "Semibold Italic" },
      { Title: "Semibold", Value: "Semibold" },
    ],
  },
  TextButtonFontFamily: {
    type: "combo",
    label: "Font Family",
    children: [
      // { Title: "Select", style: { fontFamily: "" }, Value: "Select" },
      ...externalFontsArray,   
      { Title: "Verdana", style: { fontFamily: "Verdana" }, Value: "Verdana" },
      {
        Title: "Merriweather",
        style: { fontFamily: "Merriweather" },
        Value: "Merriweather",
      },
      {
        Title: "Sans-Serif",
        style: { fontFamily: "Sans-Serif" },
        Value: "Sans-Serif",
      },
      { Title: "Exo", style: { fontFamily: "Exo" }, Value: "Exo" },
      { Title: "Arvo", style: { fontFamily: "Arvo" }, Value: "Arvo" },
      { Title: "Arial", style: { fontFamily: "Arial" }, Value: "Arial" },
      {
        Title: "Segoe UI",
        style: { fontFamily: "Segoe UI" },
        Value: "Segoe UI",
      },
      { Title: "Georgia", style: { fontFamily: "georgia" }, Value: "georgia" },
      {
        Title: "Courier-New",
        style: { fontFamily: "courier-new" },
        Value: "courier-new",
      },
      { Title: "Calibri", style: { fontFamily: "calibri" }, Value: "calibri" },
      {
        Title: "Lucida Console",
        style: { fontFamily: "Lucida Console" },
        Value: "Lucida Console",
      },
      // {'Title':'Oblique', 'Value':'oblique'},
      {
        Title: "Times New Roman",
        style: { fontFamily: "Times New Roman" },
        Value: "Times New Roman",
      },
      {
        Title: "Comic Sans MS",
        style: { fontFamily: "Comic Sans MS" },
        Value: "Comic Sans MS",
      },
      // {'Title':'Sans-Serif','style':{fontFamily:"sans-serif"}, 'Value':'sans-serif'},
      {
        Title: "Open Sans",
        style: { fontFamily: "Open Sans" },
        Value: "Open Sans",
      },
      { Title: "Gotham", style: { fontFamily: "Gotham" }, Value: "Gotham" },
      {
        Title: "Product Sans",
        style: { fontFamily: "Product Sans" },
        Value: "Product Sans",
      },
      {
        Title: "Helvetica Neue",
        style: { fontFamily: "Helvetica Neue" },
        Value: "Helvetica Neue",
      },
      { Title: "Roboto", style: { fontFamily: "Roboto" }, Value: "Roboto" },
      { Title: "Tahoma", style: { fontFamily: "Tahoma" }, Value: "Tahoma" },
      {
        Title: "Source Sans Pro",
        style: { fontFamily: "Source Sans Pro" },
        Value: "Source Sans Pro",
      },
      {
        Title: "Work Sans",
        style: { fontFamily: "Work Sans" },
        Value: "Work Sans",
      },
      {
        Title: "Playfair Display",
        style: { fontFamily: "Playfair Display" },
        Value: "Playfair Display",
      },
    ],
  },
  TextButtonFontSize: {
    type: "combo",
    label: "Font Size",
    children: [
      // { Title: "Select", style: { fontSize: "" }, Value: "Select" },
      { Title: "10", style: { fontSize: "12px" }, Value: "10px" },
      { Title: "11", style: { fontSize: "12px" }, Value: "11px" },
      { Title: "12", style: { fontSize: "12px" }, Value: "12px" },
      { Title: "13", style: { fontSize: "12px" }, Value: "13px" },
      { Title: "14", style: { fontSize: "12px" }, Value: "14px" },
      { Title: "15", style: { fontSize: "12px" }, Value: "15px" },
      { Title: "16", style: { fontSize: "12px" }, Value: "16px" },
      { Title: "17", style: { fontSize: "12px" }, Value: "17px" },
      { Title: "18", style: { fontSize: "12px" }, Value: "18px" },
      { Title: "19", style: { fontSize: "12px" }, Value: "19px" },
      { Title: "20", style: { fontSize: "12px" }, Value: "20px" },
      { Title: "21", style: { fontSize: "12px" }, Value: "21px" },
      { Title: "22", style: { fontSize: "12px" }, Value: "22px" },
      { Title: "23", style: { fontSize: "12px" }, Value: "23px" },
      { Title: "24", style: { fontSize: "12px" }, Value: "24px" },
      { Title: "25", style: { fontSize: "12px" }, Value: "25px" },
      { Title: "26", style: { fontSize: "12px" }, Value: "26px" },
      { Title: "27", style: { fontSize: "12px" }, Value: "27px" },
      { Title: "28", style: { fontSize: "12px" }, Value: "28px" },
      { Title: "29", style: { fontSize: "12px" }, Value: "29px" },
      { Title: "30", style: { fontSize: "12px" }, Value: "30px" },
    ],
  },
  TextButtonFontColor: {
    type: "colorpicker",
    label: "Font Color",
    children: [],
    regexType: "Fontcolor",
  },
  TextButtonBackgroundColor: {
    type: "colorpicker",
    label: "Background Color",
    children: [],
    regexType: "Fontcolor",
  },
  TextButtonBorderColor: {
    type: "colorpicker",
    label: "Border Color",
    children: [],
    regexType: "Fontcolor",
  },
  TextButtonBorderWidth: {
    type: "combo",
    label: "Border Width",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
    ],
  },

  TextButtonBorderRadius: {
    type: "combo",
    label: "Border Radius",
    children: [
      { Title: "Select", Value: "" },
      { Title: "0", Value: "0px" },
      { Title: "1", Value: "1px" },
      { Title: "2", Value: "2px" },
      { Title: "3", Value: "3px" },
      { Title: "4", Value: "4px" },
      { Title: "5", Value: "5px" },
      { Title: "6", Value: "6px" },
      { Title: "7", Value: "7px" },
      { Title: "8", Value: "8px" },
      { Title: "9", Value: "9px" },
      { Title: "10", Value: "10px" },
    ],
  },

  nonDraggableElementsForListviewlayout: [
    "textbox",
    "textarea",
    "datepick",
    "slider",
    "listbox",
    "combo",
    "radio",
    "checkbox",
    "Checkbox Group",
    "toggle",
    "Toggle Group",
    "tile",
    "picklist",
    "richtexteditor",
    "button",
    "Button Group",
    "link",
    "label",
    "paragraph",
    "table",
    "doclist",
    "listview",
    "advancelistview",
    "video",
    "image",
    "imagecarousel",
    ,
    "section",
    "tab",
    "sidenavigation",
    "wizard_h",
    "wizard_v",
    "report",
    "iframe",
    "captcha",
    "Survey",
    "Comparison",
    "FAQ",
    "Chatbot",
  ],
  defaultForm: {
    children: [
      { style: {}, id: "GroupInfo" },
      {
        children: [{ style: {}, id: "Event" }],
        style: {},
        id: "RootControl",
        event: { name: "Event", Event: [{ Events: [], name: "Events" }] },
        elem_type: "form",
      },
    ],
    formName: "testForm",
    ElementCount: {},
    theme: {
      themeName: "Default Theme",
      ActiveStateStyle: { ActiveStates: "#0072c6" },
      SectionStyle: {
        ControlStyle: "Style3",
        FontFamily: "Open Sans",
        FontSize: "12px",
        HeaderBackColor: "#0072c6",
        FontColor: "#168EDD",
        BorderColor: "#E4E4E4",
        FontWeight: "Bold",
      },
      InputStyle: {
        ValueFontWeight: "Normal",
        ValueFontSize: "12pt",
        ValueFontFamily: "Open Sans",
        BorderRadius: "2pt",
        BorderColor: "#DFE3E9",
        LabelFontWeight: "Bold",
        BorderWidth: "1pt",
        LabelValueAlignment: "Top Bottom",
        LabelFontColor: "#0F1217",
        ValueFontColor: "#414141",
        ControlStyleTextbox: "Style1",
        LabelFontSize: "12pt",
        LabelFontFamily: "Open Sans",
      },
      BasicTheme: {
        TabSelectionsHeaderColor: "#168edd",
        ActiveStates: "#0072c6",
      },
      TabSheetStyle: { TabSelectionsHeaderColor: "#168edd" },
      ButtonStyle: {
        FontFamily: "Open Sans",
        CornerRadius: "2pt",
        FontSize: "12pt",
        FontColor: "#FFFFFF",
        FontWeight: "Bold",
        BackgroundColor: "#FFFFFF",
      },
      HorizontalTabStyle: {
        ControlStyle: "Style3",
        ActiveTabBackColor: "#FFFFFF",
        InActiveTabBackColor: "#168EDD",
        BorderRadius: "2pt",
        InActiveTabFontColor: "#FFFFFF",
        ActiveTabFontColor: "#168EDD",
      },
      TableStyle: {
        TableColumnBackgroundColor: "#168EDD14",
        TableColumnFontSize: "14pt",
        TableColumnFontColor: "#000000",
        TableColumnFontWeight: "Bold",
        TableTitleFontColor: "#168EDD",
        TableRowFontSize: "14pt",
        TableRowFontWeight: "Bold",
        TableRowBackgroundColor: "#FFFFFF",
        TableTitleFontFamily: "Open Sans",
        ControlStyle: "Box",
        TableTitleFontWeight: "Bold",
        TableTitleFontSize: "14pt",
        TableRowFontColor: "#000000",
        TableRowFontFamily: "Open Sans",
        TableColumnFontFamily: "Open Sans",
      },
    },
    style: {
      FontStyle: "1",
      CombinedFontWeight: "Bold",
      ImageAllignment: "Center",
      HeaderAllignment: "center",
      FormMaxWidth: "",
      FormAllignments: "",
      GradientPercent1: "0",
      GradientPercent2: "100",
      FormWidth: "100",
      height: "100%",
      ScreenBackgroundRadio: "bgcolor",
      WidthOfWeb: 1241,
      FontColor: "#000000",
      GradientAngles: "",
      FormBackgroundColor: "#ffffff",
      WidthOfCanvas: 1241,
      FontSize: "18pt",
      FormBorderColor: "#d7d7d7",
      ScreenBgImgWidth: "",
      MenuInactiveColor: "#",
      ScreenBackgroundColor: "#ffffff",
      ImageFormUrl: "",
      GradientColor1: "#transparent",
      BGActiveColor: "#",
      GradientColor2: "#transparent",
      ScreenBackgroundImage: "",
      FormWidthType: "1",
      FontWeight: "2",
      FormBorderWidth: "0pt",
      FormHorizontal: "false",
      FormVertical: "center",
      MenuActiveColor: "#",
      ShowHeader: "true",
      BoderSize: "0",
      TopPercent: "0",
      FontFamily: "2",
      Breakpoint: {
        Desktop: { StartValue: "1000", EndValue: "1250" },
        Tab: { StartValue: "750", EndValue: "1000" },
        Mobile: { StartValue: "320", EndValue: "750" },
      },
      CurrentDevice: {},
      BackColor: "#ffffff",
      BackColorBoundary: "#ffffff",
      LeftPercent: "0",
      FitToContentHeight: "false",
      FixHeader: "1",
      FormMinWidth: "",
      InputStyle: "",
      width: "100%",
      CanvasWidth: 1241,
      BGInactiveColor: "#",
      AddGradient: "false",
      RightPercent: "0",
    },
    ControlType: "form",
    id: "FormDef",
    elem_type: "form",
  },

  HeaderTitle: {
    type: "header",
    label: "Header Title",
  },
  HeaderBackground: {
    type: "header",
    label: "Header Background",
  },
  PageTitle: {
    type: "text_top_bottom",
    label: "Page Title",
    children: [],
    regexType: "Allchar",
  },
  "buttonName" :{
    "type":"buttonname"
  },
  Route: {
    type: "combo",
    label: "Route Page on Logo Click",
    children: [],
    alignment: "left",
    styleKey: "route",
  },
};

export default ControlsMap;

(function refreshFontFamilyEntries() {
  function getExternalFontsArray() {
    if (!window.getExternalFonts) return [];
    return window.getExternalFonts().map(function(fontName) {
      return { Title: fontName, style: { fontFamily: fontName, color: "#0072c6" }, Value: fontName };
    });
  }

  Object.keys(ControlsMap).forEach(function(key) {
    var entry = ControlsMap[key];
    if (entry && entry.type === "combo" && Array.isArray(entry.children) && key.toLowerCase().includes("fontfamily")) {
      // Capture the static children (strip any external fonts that were spread at load time)
      var staticChildren = entry.children.filter(function(c) { return c && c.style && c.style.color !== "#0072c6"; });
      Object.defineProperty(entry, "children", {
        get: function() {
          var extFonts = getExternalFontsArray();
          return [staticChildren[0]].concat(extFonts, staticChildren.slice(1));
        },
        configurable: true,
        enumerable: true,
      });
    }
  });
})();